/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { ActivationLinkDto } from '../models/ActivationLinkDto';
import type { AddBenefitToCartDto } from '../models/AddBenefitToCartDto';
import type { AddressValidationRequest } from '../models/AddressValidationRequest';
import type { AddressValidationResponse } from '../models/AddressValidationResponse';
import type { AgencyDto } from '../models/AgencyDto';
import type { AgencyReportRowDto } from '../models/AgencyReportRowDto';
import type { AgentDto } from '../models/AgentDto';
import type { AgentReportRowDto } from '../models/AgentReportRowDto';
import type { AllAgenciesDto } from '../models/AllAgenciesDto';
import type { AllQuoteScenariosDto } from '../models/AllQuoteScenariosDto';
import type { AllowanceModelCalculationRequestDto } from '../models/AllowanceModelCalculationRequestDto';
import type { AllowanceModelCalculationResponseDto } from '../models/AllowanceModelCalculationResponseDto';
import type { AllowanceModelDto } from '../models/AllowanceModelDto';
import type { AllowanceModelSourceMetadataDto } from '../models/AllowanceModelSourceMetadataDto';
import type { ApplyAllowanceModelRequestDto } from '../models/ApplyAllowanceModelRequestDto';
import type { AssignBenefitEnrollmentAgentDto } from '../models/AssignBenefitEnrollmentAgentDto';
import type { AssignEnrollmentTeamDto } from '../models/AssignEnrollmentTeamDto';
import type { AvailableSubmissionMethodsDto } from '../models/AvailableSubmissionMethodsDto';
import type { AvgPremiumsResult } from '../models/AvgPremiumsResult';
import type { BenefitDocumentDto } from '../models/BenefitDocumentDto';
import type { BenefitDto } from '../models/BenefitDto';
import type { BenefitType } from '../models/BenefitType';
import type { BenefitsRequiringStatusUpdateDto } from '../models/BenefitsRequiringStatusUpdateDto';
import type { BulkGenerateIchraLettersDto } from '../models/BulkGenerateIchraLettersDto';
import type { BulkTemplateDto } from '../models/BulkTemplateDto';
import type { CarePreferencesDto } from '../models/CarePreferencesDto';
import type { CarrierContextComparisonPageDto } from '../models/CarrierContextComparisonPageDto';
import type { CarrierContextIssuesDto } from '../models/CarrierContextIssuesDto';
import type { CarrierInfoDto } from '../models/CarrierInfoDto';
import type { CarrierInfoWithoutIdDto } from '../models/CarrierInfoWithoutIdDto';
import type { CarrierPaymentDto } from '../models/CarrierPaymentDto';
import type { CarrierRowsDto } from '../models/CarrierRowsDto';
import type { CarriersPlansBenefitsCarrierDto } from '../models/CarriersPlansBenefitsCarrierDto';
import type { CarryOverSourceQuoteDto } from '../models/CarryOverSourceQuoteDto';
import type { CensusEmployeeDto } from '../models/CensusEmployeeDto';
import type { ChangeCustomerFacingRolesDto } from '../models/ChangeCustomerFacingRolesDto';
import type { ChangeCustomerFacingRolesResultDto } from '../models/ChangeCustomerFacingRolesResultDto';
import type { ClassDefinitionDto } from '../models/ClassDefinitionDto';
import type { ClassDefinitionsForEmployerResultDto } from '../models/ClassDefinitionsForEmployerResultDto';
import type { CmsQualityRatingsUploadDto } from '../models/CmsQualityRatingsUploadDto';
import type { CmsQualityRatingsUploadSummaryDto } from '../models/CmsQualityRatingsUploadSummaryDto';
import type { CommunicationDisplayConditionsDto } from '../models/CommunicationDisplayConditionsDto';
import type { CompanyEmailInUseDto } from '../models/CompanyEmailInUseDto';
import type { CompanyOverviewDto } from '../models/CompanyOverviewDto';
import type { CostPreferenceDto } from '../models/CostPreferenceDto';
import type { CountyDto } from '../models/CountyDto';
import type { CreateActivationLinkDto } from '../models/CreateActivationLinkDto';
import type { CreateAgencyDto } from '../models/CreateAgencyDto';
import type { CreateAgentDto } from '../models/CreateAgentDto';
import type { CreateApplicationResultDto } from '../models/CreateApplicationResultDto';
import type { CreateAutomaticApplicationDto } from '../models/CreateAutomaticApplicationDto';
import type { CreateBenefitDocumentDto } from '../models/CreateBenefitDocumentDto';
import type { CreateBookTransferDto } from '../models/CreateBookTransferDto';
import type { CreateDeallocationDto } from '../models/CreateDeallocationDto';
import type { CreateDeallocationForDeletedBenefitDto } from '../models/CreateDeallocationForDeletedBenefitDto';
import type { CreateEmergencyReservePullDto } from '../models/CreateEmergencyReservePullDto';
import type { CreateEmployeeDto } from '../models/CreateEmployeeDto';
import type { CreateEmployeePaymentMethodPayloadDto } from '../models/CreateEmployeePaymentMethodPayloadDto';
import type { CreateEmployeePaymentsAccountResponseDto } from '../models/CreateEmployeePaymentsAccountResponseDto';
import type { CreateEmployeeReserveAccountDto } from '../models/CreateEmployeeReserveAccountDto';
import type { CreateEmployerBankAccountDto } from '../models/CreateEmployerBankAccountDto';
import type { CreateEmployerContactDto } from '../models/CreateEmployerContactDto';
import type { CreateEmployerDocumentDto } from '../models/CreateEmployerDocumentDto';
import type { CreateEmployerDto } from '../models/CreateEmployerDto';
import type { CreateEnrollmentActivityLogRequestDto } from '../models/CreateEnrollmentActivityLogRequestDto';
import type { CreateEnrollmentCommentDto } from '../models/CreateEnrollmentCommentDto';
import type { CreateImmediateAllocationDto } from '../models/CreateImmediateAllocationDto';
import type { CreateInitialAllocationDto } from '../models/CreateInitialAllocationDto';
import type { CreateInitialDrawDto } from '../models/CreateInitialDrawDto';
import type { CreateManyUsersDto } from '../models/CreateManyUsersDto';
import type { CreateMonthlyBillingAllocationsDto } from '../models/CreateMonthlyBillingAllocationsDto';
import type { CreateMonthlyBillingContributionDto } from '../models/CreateMonthlyBillingContributionDto';
import type { CreateOnboardingPeriodByAdminDto } from '../models/CreateOnboardingPeriodByAdminDto';
import type { CreateOnboardingPeriodByEmployeeDto } from '../models/CreateOnboardingPeriodByEmployeeDto';
import type { CreateOpenEnrollmentPeriodDto } from '../models/CreateOpenEnrollmentPeriodDto';
import type { CreatePaymentsEmployee } from '../models/CreatePaymentsEmployee';
import type { CreatePaymentsEmployerDto } from '../models/CreatePaymentsEmployerDto';
import type { CreateQuoteDto } from '../models/CreateQuoteDto';
import type { CreateQuotePlanDesignDto } from '../models/CreateQuotePlanDesignDto';
import type { CreateRenewalReviewSnapshotDto } from '../models/CreateRenewalReviewSnapshotDto';
import type { CreateSavedPlanRequestDto } from '../models/CreateSavedPlanRequestDto';
import type { CreateUserDto } from '../models/CreateUserDto';
import type { CreateWorkflowRequestDto } from '../models/CreateWorkflowRequestDto';
import type { CreateWorkflowResponseDto } from '../models/CreateWorkflowResponseDto';
import type { DateRangeDto } from '../models/DateRangeDto';
import type { DependentsDtoResult } from '../models/DependentsDtoResult';
import type { DiscoveryAiChatImpersonationAccessDto } from '../models/DiscoveryAiChatImpersonationAccessDto';
import type { DiscoveryPlanSearchRequestDto } from '../models/DiscoveryPlanSearchRequestDto';
import type { DiscoveryPlanSearchResponseDto } from '../models/DiscoveryPlanSearchResponseDto';
import type { DrugDto } from '../models/DrugDto';
import type { ElectionReviewSnapshotDto } from '../models/ElectionReviewSnapshotDto';
import type { EmailDto } from '../models/EmailDto';
import type { EmployeeBankAccountResponseDto } from '../models/EmployeeBankAccountResponseDto';
import type { EmployeeBreakdownDto } from '../models/EmployeeBreakdownDto';
import type { EmployeeCardsDto } from '../models/EmployeeCardsDto';
import type { EmployeeClassesDto } from '../models/EmployeeClassesDto';
import type { EmployeeCount } from '../models/EmployeeCount';
import type { EmployeeDto } from '../models/EmployeeDto';
import type { EmployeeInfoDto } from '../models/EmployeeInfoDto';
import type { EmployeePaymentMethodDetailsDto } from '../models/EmployeePaymentMethodDetailsDto';
import type { EmployeePaymentMethodDetailsPayloadDto } from '../models/EmployeePaymentMethodDetailsPayloadDto';
import type { EmployeePaymentMethodDto } from '../models/EmployeePaymentMethodDto';
import type { EmployeePaymentsAccountStatusDto } from '../models/EmployeePaymentsAccountStatusDto';
import type { EmployerAgenciesDto } from '../models/EmployerAgenciesDto';
import type { EmployerBeneficialOwnerDto } from '../models/EmployerBeneficialOwnerDto';
import type { EmployerContactsByType } from '../models/EmployerContactsByType';
import type { EmployerContributionDto } from '../models/EmployerContributionDto';
import type { EmployerDocumentDto } from '../models/EmployerDocumentDto';
import type { EmployerDto } from '../models/EmployerDto';
import type { EmployerExternalBankAccountDetailsResponseDto } from '../models/EmployerExternalBankAccountDetailsResponseDto';
import type { EmployerKybStatusResponseDto } from '../models/EmployerKybStatusResponseDto';
import type { EmployerPublicInfoDto } from '../models/EmployerPublicInfoDto';
import type { EmployerReportRowDto } from '../models/EmployerReportRowDto';
import type { EmployerSummaryDto } from '../models/EmployerSummaryDto';
import type { EmployerUpdateResponseDto } from '../models/EmployerUpdateResponseDto';
import type { EmploymentCandidatesSyncCountsDto } from '../models/EmploymentCandidatesSyncCountsDto';
import type { EnrollmentActivityLogDto } from '../models/EnrollmentActivityLogDto';
import type { EnrollmentActivityLogGroupDto } from '../models/EnrollmentActivityLogGroupDto';
import type { EnrollmentCommentDto } from '../models/EnrollmentCommentDto';
import type { EnrollmentConfirmationDto } from '../models/EnrollmentConfirmationDto';
import type { EnrollmentConfirmationResultDto } from '../models/EnrollmentConfirmationResultDto';
import type { EnrollmentDto } from '../models/EnrollmentDto';
import type { EnrollmentEmailPaymentOptionsDto } from '../models/EnrollmentEmailPaymentOptionsDto';
import type { EnrollmentInstructionsDto } from '../models/EnrollmentInstructionsDto';
import type { EnrollmentReviewBenefitItemsDto } from '../models/EnrollmentReviewBenefitItemsDto';
import type { EnrollmentSepDocumentDto } from '../models/EnrollmentSepDocumentDto';
import type { EnrollmentSummaryRequestDto } from '../models/EnrollmentSummaryRequestDto';
import type { EnrollmentSummaryResponseDto } from '../models/EnrollmentSummaryResponseDto';
import type { EventDto } from '../models/EventDto';
import type { ExecuteTaskRequestDto } from '../models/ExecuteTaskRequestDto';
import type { ExecuteTaskResponseDto } from '../models/ExecuteTaskResponseDto';
import type { FamilyUnit } from '../models/FamilyUnit';
import type { FetchOnboardingPeriodStatusesRequestDto } from '../models/FetchOnboardingPeriodStatusesRequestDto';
import type { FinancialRiskToleranceDto } from '../models/FinancialRiskToleranceDto';
import type { FinchConnectCallbackDto } from '../models/FinchConnectCallbackDto';
import type { FinchConnectDto } from '../models/FinchConnectDto';
import type { FinchConnectResponseDto } from '../models/FinchConnectResponseDto';
import type { FinchEmployeeDto } from '../models/FinchEmployeeDto';
import type { FinchEmployerDto } from '../models/FinchEmployerDto';
import type { FinchEmployerEligibilityDto } from '../models/FinchEmployerEligibilityDto';
import type { FinchEmploymentExportDto } from '../models/FinchEmploymentExportDto';
import type { FinchPaymentDto } from '../models/FinchPaymentDto';
import type { FinchProviderDto } from '../models/FinchProviderDto';
import type { FindManyOnboardingPeriodsDto } from '../models/FindManyOnboardingPeriodsDto';
import type { GenerateActivationLinkResponseDto } from '../models/GenerateActivationLinkResponseDto';
import type { GenerateCsvDto } from '../models/GenerateCsvDto';
import type { GenerateEmployeesReportDto } from '../models/GenerateEmployeesReportDto';
import type { GenerateEnrollmentsReportDto } from '../models/GenerateEnrollmentsReportDto';
import type { GeneratePayrollReportDto } from '../models/GeneratePayrollReportDto';
import type { GenerateProspectsReportDto } from '../models/GenerateProspectsReportDto';
import type { GenerateQuoteOutputRequestDto } from '../models/GenerateQuoteOutputRequestDto';
import type { GeoClassesCountResult } from '../models/GeoClassesCountResult';
import type { GetAllowanceModelDto } from '../models/GetAllowanceModelDto';
import type { GetByUserIdsDto } from '../models/GetByUserIdsDto';
import type { GetCensusPlanDto } from '../models/GetCensusPlanDto';
import type { GetEmployeePaymentsAccount } from '../models/GetEmployeePaymentsAccount';
import type { GetEmployerContributionByInsuredIdsDto } from '../models/GetEmployerContributionByInsuredIdsDto';
import type { GetEmployerDto } from '../models/GetEmployerDto';
import type { GetPlanSearchModeDto } from '../models/GetPlanSearchModeDto';
import type { GetQuoteDto } from '../models/GetQuoteDto';
import type { GetSolutionsDto } from '../models/GetSolutionsDto';
import type { GetUserRolesDto } from '../models/GetUserRolesDto';
import type { GetZipCodeDto } from '../models/GetZipCodeDto';
import type { IchraLetterDto } from '../models/IchraLetterDto';
import type { InitialAllocationStatusResponseDto } from '../models/InitialAllocationStatusResponseDto';
import type { InsuredPeopleDto } from '../models/InsuredPeopleDto';
import type { IntercomSyncStatus } from '../models/IntercomSyncStatus';
import type { IntercomUserHashPayloadDto } from '../models/IntercomUserHashPayloadDto';
import type { IntercomUserHashResponseDto } from '../models/IntercomUserHashResponseDto';
import type { LastSubmittedPeriodIdDto } from '../models/LastSubmittedPeriodIdDto';
import type { LeaveOfAbsenceDto } from '../models/LeaveOfAbsenceDto';
import type { LinkedEmployeesSyncCountsDto } from '../models/LinkedEmployeesSyncCountsDto';
import type { ListTasksResponseDto } from '../models/ListTasksResponseDto';
import type { ListWorkflowsResponseDto } from '../models/ListWorkflowsResponseDto';
import type { LogEnrollmentCallDto } from '../models/LogEnrollmentCallDto';
import type { MajorMedicalCarrierDto } from '../models/MajorMedicalCarrierDto';
import type { MajorMedicalDrug } from '../models/MajorMedicalDrug';
import type { MajorMedicalProvider } from '../models/MajorMedicalProvider';
import type { MajorMedicalSpecialtyCategory } from '../models/MajorMedicalSpecialtyCategory';
import type { ManualElectionReviewSnapshotDto } from '../models/ManualElectionReviewSnapshotDto';
import type { MedicalPlan } from '../models/MedicalPlan';
import type { MedicalPlanForEnrollment } from '../models/MedicalPlanForEnrollment';
import type { MedicalPlanSearchRequest } from '../models/MedicalPlanSearchRequest';
import type { MonthlyBillingContributionResponseDto } from '../models/MonthlyBillingContributionResponseDto';
import type { NotifyEnrollmentTeamAssignmentDto } from '../models/NotifyEnrollmentTeamAssignmentDto';
import type { OnboardingPeriodBenefitsDto } from '../models/OnboardingPeriodBenefitsDto';
import type { OnboardingPeriodDto } from '../models/OnboardingPeriodDto';
import type { OnboardingPeriodReportDto } from '../models/OnboardingPeriodReportDto';
import type { OnboardingPeriodWithEnrollmentStatusDto } from '../models/OnboardingPeriodWithEnrollmentStatusDto';
import type { OpenEnrollmentPeriodDto } from '../models/OpenEnrollmentPeriodDto';
import type { OpenEnrollmentPeriodUpdateErrorDto } from '../models/OpenEnrollmentPeriodUpdateErrorDto';
import type { OpenEnrollmentPeriodsRelevancyMode } from '../models/OpenEnrollmentPeriodsRelevancyMode';
import type { PaginatedEmployeesReportRowDto } from '../models/PaginatedEmployeesReportRowDto';
import type { PaginatedEmployerOnboardingReportDto } from '../models/PaginatedEmployerOnboardingReportDto';
import type { PaginatedEnrollmentReportRowDto } from '../models/PaginatedEnrollmentReportRowDto';
import type { PaginatedPayrollReportRowDto } from '../models/PaginatedPayrollReportRowDto';
import type { PaginatedProspectsReportRowDto } from '../models/PaginatedProspectsReportRowDto';
import type { PasswordResetDto } from '../models/PasswordResetDto';
import type { PatchMajorMedicalPlanDto } from '../models/PatchMajorMedicalPlanDto';
import type { PlanAttestationsDto } from '../models/PlanAttestationsDto';
import type { PlanExclusionFilter } from '../models/PlanExclusionFilter';
import type { PlanExclusionFilterSetDto } from '../models/PlanExclusionFilterSetDto';
import type { PlanIssuerDto } from '../models/PlanIssuerDto';
import type { PlanSearchSelfDto } from '../models/PlanSearchSelfDto';
import type { PlanSummaryDto } from '../models/PlanSummaryDto';
import type { PossibleEmployerContributionDto } from '../models/PossibleEmployerContributionDto';
import type { PresetWithContributionAndGeoDistribution } from '../models/PresetWithContributionAndGeoDistribution';
import type { PriorVendorBenefitDto } from '../models/PriorVendorBenefitDto';
import type { ProviderPreferenceDto } from '../models/ProviderPreferenceDto';
import type { PublicMedicalPlanSearchRequest } from '../models/PublicMedicalPlanSearchRequest';
import type { QuoteAllowanceModelRow } from '../models/QuoteAllowanceModelRow';
import type { QuotePlanDesignDto } from '../models/QuotePlanDesignDto';
import type { QuoteSessionDto } from '../models/QuoteSessionDto';
import type { RecommendationDataDto } from '../models/RecommendationDataDto';
import type { RecommendationDataInputDto } from '../models/RecommendationDataInputDto';
import type { RecommendationDataSearchDto } from '../models/RecommendationDataSearchDto';
import type { RenewalDto } from '../models/RenewalDto';
import type { RenewalPriceRequestDto } from '../models/RenewalPriceRequestDto';
import type { RenewalRateChangeDto } from '../models/RenewalRateChangeDto';
import type { RenewalReviewSnapshotDto } from '../models/RenewalReviewSnapshotDto';
import type { ReportSupportIssuePayloadDto } from '../models/ReportSupportIssuePayloadDto';
import type { ResumeWorkflowDto } from '../models/ResumeWorkflowDto';
import type { ResumeWorkflowResponseDto } from '../models/ResumeWorkflowResponseDto';
import type { SavedPlanDto } from '../models/SavedPlanDto';
import type { ScheduleMonthlyBillingWorkflowsRequestDto } from '../models/ScheduleMonthlyBillingWorkflowsRequestDto';
import type { ScheduleMonthlyBillingWorkflowsResponseDto } from '../models/ScheduleMonthlyBillingWorkflowsResponseDto';
import type { SearchCensusEmployeesRequestDto } from '../models/SearchCensusEmployeesRequestDto';
import type { SearchMajorMedicalCarriersPayloadDto } from '../models/SearchMajorMedicalCarriersPayloadDto';
import type { SearchResultDto } from '../models/SearchResultDto';
import type { SelectedDependentsDto } from '../models/SelectedDependentsDto';
import type { SendCobraEmailsRequestDto } from '../models/SendCobraEmailsRequestDto';
import type { SingleOnboardingPeriodStatusesDto } from '../models/SingleOnboardingPeriodStatusesDto';
import type { SolutionsResponseDto } from '../models/SolutionsResponseDto';
import type { StartQuoteGenerationResultDto } from '../models/StartQuoteGenerationResultDto';
import type { StateAppointmentDto } from '../models/StateAppointmentDto';
import type { StateAppointmentWithoutIdDto } from '../models/StateAppointmentWithoutIdDto';
import type { StateDistributionResultDto } from '../models/StateDistributionResultDto';
import type { StopWorkflowDto } from '../models/StopWorkflowDto';
import type { SubEntityDto } from '../models/SubEntityDto';
import type { SubmitElectionDto } from '../models/SubmitElectionDto';
import type { SubmitSelfReportElectionDto } from '../models/SubmitSelfReportElectionDto';
import type { SubmittedApplicationResultDto } from '../models/SubmittedApplicationResultDto';
import type { SupplementalPlanDto } from '../models/SupplementalPlanDto';
import type { SupplementalPlanForEnrollment } from '../models/SupplementalPlanForEnrollment';
import type { SupplementalPlanSearchRequest } from '../models/SupplementalPlanSearchRequest';
import type { SupplementalQuoteRequest } from '../models/SupplementalQuoteRequest';
import type { SyncAgencyNameDto } from '../models/SyncAgencyNameDto';
import type { SyncEmployeeNameDto } from '../models/SyncEmployeeNameDto';
import type { SyncEmployerNameDto } from '../models/SyncEmployerNameDto';
import type { TaskWithErrorsDto } from '../models/TaskWithErrorsDto';
import type { TemplateDto } from '../models/TemplateDto';
import type { TerminateEmployeeDto } from '../models/TerminateEmployeeDto';
import type { TriggerDueRequestsResponseDto } from '../models/TriggerDueRequestsResponseDto';
import type { TriggerRequestResponseDto } from '../models/TriggerRequestResponseDto';
import type { TriggerWorkflowDto } from '../models/TriggerWorkflowDto';
import type { USState } from '../models/USState';
import type { UpdateAgencyDto } from '../models/UpdateAgencyDto';
import type { UpdateAgentDto } from '../models/UpdateAgentDto';
import type { UpdateAnticipatedCareLevelsDto } from '../models/UpdateAnticipatedCareLevelsDto';
import type { UpdateAorConfirmedByEmployeeDto } from '../models/UpdateAorConfirmedByEmployeeDto';
import type { UpdateApplicationSubmissionMethodDto } from '../models/UpdateApplicationSubmissionMethodDto';
import type { UpdateBenefitDocumentDto } from '../models/UpdateBenefitDocumentDto';
import type { UpdateBenefitPaymentMethodOverrideDto } from '../models/UpdateBenefitPaymentMethodOverrideDto';
import type { UpdateBenefitPaymentStatusDto } from '../models/UpdateBenefitPaymentStatusDto';
import type { UpdateBenefitPremiumDto } from '../models/UpdateBenefitPremiumDto';
import type { UpdateBenefitSelfPayDto } from '../models/UpdateBenefitSelfPayDto';
import type { UpdateBenefitStatusDto } from '../models/UpdateBenefitStatusDto';
import type { UpdateCustomClassCategoryDto } from '../models/UpdateCustomClassCategoryDto';
import type { UpdateDecisionFactorsDto } from '../models/UpdateDecisionFactorsDto';
import type { UpdateEligibilityDto } from '../models/UpdateEligibilityDto';
import type { UpdateEmployeeDto } from '../models/UpdateEmployeeDto';
import type { UpdateEmployeeInfoDto } from '../models/UpdateEmployeeInfoDto';
import type { UpdateEmployeePaymentMethodAssociatedBenefitsPayloadDto } from '../models/UpdateEmployeePaymentMethodAssociatedBenefitsPayloadDto';
import type { UpdateEmployeePaymentMethodPayloadDto } from '../models/UpdateEmployeePaymentMethodPayloadDto';
import type { UpdateEmployeeReservePurseAmountDto } from '../models/UpdateEmployeeReservePurseAmountDto';
import type { UpdateEmployerDocumentDto } from '../models/UpdateEmployerDocumentDto';
import type { UpdateEmployerDto } from '../models/UpdateEmployerDto';
import type { UpdateEnrollmentCommentDto } from '../models/UpdateEnrollmentCommentDto';
import type { UpdateEnrollmentTagsDto } from '../models/UpdateEnrollmentTagsDto';
import type { UpdateFinchEmployerDto } from '../models/UpdateFinchEmployerDto';
import type { UpdateInitialDrawDto } from '../models/UpdateInitialDrawDto';
import type { UpdateMajorMedicalCarriersDto } from '../models/UpdateMajorMedicalCarriersDto';
import type { UpdateMajorMedicalCarriersResponseDto } from '../models/UpdateMajorMedicalCarriersResponseDto';
import type { UpdateOnboardingPeriodAllowanceDto } from '../models/UpdateOnboardingPeriodAllowanceDto';
import type { UpdateOnboardingPeriodByAdminDto } from '../models/UpdateOnboardingPeriodByAdminDto';
import type { UpdateOpenEnrollmentPeriodDto } from '../models/UpdateOpenEnrollmentPeriodDto';
import type { UpdateQuoteDto } from '../models/UpdateQuoteDto';
import type { UpdateQuotePlanDesignDto } from '../models/UpdateQuotePlanDesignDto';
import type { UpdateSubmittedPlanDto } from '../models/UpdateSubmittedPlanDto';
import type { UpsertAllowanceModelDto } from '../models/UpsertAllowanceModelDto';
import type { UpsertAllowanceModelResponseDto } from '../models/UpsertAllowanceModelResponseDto';
import type { UpsertDependentsDto } from '../models/UpsertDependentsDto';
import type { UpsertEnrollmentInstructionsDto } from '../models/UpsertEnrollmentInstructionsDto';
import type { UpsertFinchEmployerEligibilityDto } from '../models/UpsertFinchEmployerEligibilityDto';
import type { UpsertInsuredPeopleDto } from '../models/UpsertInsuredPeopleDto';
import type { UpsertManualAllowanceModelSourceDto } from '../models/UpsertManualAllowanceModelSourceDto';
import type { UpsertManyEmployeesRequest } from '../models/UpsertManyEmployeesRequest';
import type { UpsertManyEmployeesResult } from '../models/UpsertManyEmployeesResult';
import type { UpsertManyUsersResponseDto } from '../models/UpsertManyUsersResponseDto';
import type { UpsertPriorVendorBenefitDto } from '../models/UpsertPriorVendorBenefitDto';
import type { UserAndTenantDto } from '../models/UserAndTenantDto';
import type { UserDto } from '../models/UserDto';
import type { UserDtoWithRoles } from '../models/UserDtoWithRoles';
import type { UserEmailsDto } from '../models/UserEmailsDto';
import type { UserIdsDto } from '../models/UserIdsDto';
import type { UserStatusDto } from '../models/UserStatusDto';
import type { UsersRolesDto } from '../models/UsersRolesDto';
import type { VgsCardInfoResponseDto } from '../models/VgsCardInfoResponseDto';
import type { WaiveCoverageDto } from '../models/WaiveCoverageDto';
import type { WorkflowExecutionDto } from '../models/WorkflowExecutionDto';
import type { WorkflowExecutionReportDto } from '../models/WorkflowExecutionReportDto';
import type { WorkflowStatsResponseDto } from '../models/WorkflowStatsResponseDto';
import type { WorkflowStatus } from '../models/WorkflowStatus';
import type { WorkflowTypesResponseDto } from '../models/WorkflowTypesResponseDto';

export class MonolithService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @param flagName
   * @param employerId
   * @returns boolean
   * @throws ApiError
   */
  public featureFlagControllerEmployerOn(
    flagName:
      | 'reporting_mode'
      | 'hide_payment_statuses'
      | 'skip_hsa_ma'
      | 'finch_employment_sync'
      | 'coverage_scope'
      | 'lynx_payments_enabled'
      | 'discovery_shopping'
      | 'discovery_shopping_employer'
      | 'discovery_shopping_anim_debug'
      | 'enroll_connect_enabled'
      | 'enroll_connect_sep_testing'
      | 'carrier_attestations_enabled'
      | 'awaiting_employee_benefit_status_enabled'
      | 'awaiting_payment_benefit_status_enabled'
      | 'new_discovery_design'
      | 'discovery_new_filters'
      | 'lumos_demo_shopping'
      | 'with_employee_page_actions_required'
      | 'enrollment_effort_enabled'
      | 'residential_address_step'
      | 'carrier_context_read'
      | 'carrier_context_comparison',
    employerId: string
  ): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/feature-flag/employer/{flagName}/{employerId}',
      path: {
        flagName: flagName,
        employerId: employerId,
      },
    });
  }
  /**
   * @param flagName
   * @param employeeId
   * @returns boolean
   * @throws ApiError
   */
  public featureFlagControllerEmployeeOn(
    flagName:
      | 'reporting_mode'
      | 'hide_payment_statuses'
      | 'skip_hsa_ma'
      | 'finch_employment_sync'
      | 'coverage_scope'
      | 'lynx_payments_enabled'
      | 'discovery_shopping'
      | 'discovery_shopping_employer'
      | 'discovery_shopping_anim_debug'
      | 'enroll_connect_enabled'
      | 'enroll_connect_sep_testing'
      | 'carrier_attestations_enabled'
      | 'awaiting_employee_benefit_status_enabled'
      | 'awaiting_payment_benefit_status_enabled'
      | 'new_discovery_design'
      | 'discovery_new_filters'
      | 'lumos_demo_shopping'
      | 'with_employee_page_actions_required'
      | 'enrollment_effort_enabled'
      | 'residential_address_step'
      | 'carrier_context_read'
      | 'carrier_context_comparison',
    employeeId: string
  ): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/feature-flag/employee/{flagName}/{employeeId}',
      path: {
        flagName: flagName,
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param flagName
   * @returns boolean
   * @throws ApiError
   */
  public featureFlagControllerUserOn(
    flagName:
      | 'reporting_mode'
      | 'hide_payment_statuses'
      | 'skip_hsa_ma'
      | 'finch_employment_sync'
      | 'coverage_scope'
      | 'lynx_payments_enabled'
      | 'discovery_shopping'
      | 'discovery_shopping_employer'
      | 'discovery_shopping_anim_debug'
      | 'enroll_connect_enabled'
      | 'enroll_connect_sep_testing'
      | 'carrier_attestations_enabled'
      | 'awaiting_employee_benefit_status_enabled'
      | 'awaiting_payment_benefit_status_enabled'
      | 'new_discovery_design'
      | 'discovery_new_filters'
      | 'lumos_demo_shopping'
      | 'with_employee_page_actions_required'
      | 'enrollment_effort_enabled'
      | 'residential_address_step'
      | 'carrier_context_read'
      | 'carrier_context_comparison'
  ): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/feature-flag/user/{flagName}',
      path: {
        flagName: flagName,
      },
    });
  }
  /**
   * @param requestBody
   * @returns AddressValidationResponse
   * @throws ApiError
   */
  public addressControllerValidateAddress(
    requestBody: AddressValidationRequest
  ): CancelablePromise<AddressValidationResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/address',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param zipCode
   * @returns CountyDto
   * @throws ApiError
   */
  public addressControllerGetCountiesByZipCode(
    zipCode: number
  ): CancelablePromise<Array<CountyDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/address/counties/{zipCode}',
      path: {
        zipCode: zipCode,
      },
    });
  }
  /**
   * @param requestBody
   * @returns BenefitDocumentDto
   * @throws ApiError
   */
  public benefitDocumentsControllerCreateBenefitDocument(
    requestBody: CreateBenefitDocumentDto
  ): CancelablePromise<BenefitDocumentDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/benefit-documents',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param isEmployeeFilesOnly
   * @returns BenefitDocumentDto
   * @throws ApiError
   */
  public benefitDocumentsControllerGetBenefitDocumentsByOnboardingPeriod(
    periodId: string,
    isEmployeeFilesOnly?: boolean
  ): CancelablePromise<Array<BenefitDocumentDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/benefit-documents',
      path: {
        periodId: periodId,
      },
      query: {
        isEmployeeFilesOnly: isEmployeeFilesOnly,
      },
    });
  }
  /**
   * @param benefitDocumentId
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public benefitDocumentsControllerUpdateBenefitDocument(
    benefitDocumentId: string,
    requestBody: UpdateBenefitDocumentDto
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/benefit-documents/{benefitDocumentId}',
      path: {
        benefitDocumentId: benefitDocumentId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param benefitDocumentId
   * @returns any
   * @throws ApiError
   */
  public benefitDocumentsControllerRemoveBenefitDocument(
    benefitDocumentId: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/benefit-documents/{benefitDocumentId}',
      path: {
        benefitDocumentId: benefitDocumentId,
      },
    });
  }
  /**
   * @returns TemplateDto
   * @throws ApiError
   */
  public benefitDocumentsControllerGetIchraLetterTemplate(): CancelablePromise<TemplateDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ichra-letter/template',
    });
  }
  /**
   * @param periodId
   * @param employeeId
   * @param templateId
   * @returns IchraLetterDto
   * @throws ApiError
   */
  public benefitDocumentsControllerGenerateIchraLetter(
    periodId: string,
    employeeId: string,
    templateId: string
  ): CancelablePromise<IchraLetterDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/ichra-letter',
      path: {
        periodId: periodId,
      },
      query: {
        employeeId: employeeId,
        templateId: templateId,
      },
    });
  }
  /**
   * @param requestBody
   * @returns string
   * @throws ApiError
   */
  public benefitDocumentsControllerBulkGenerateIchraLetters(
    requestBody: BulkGenerateIchraLettersDto
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/ichra-letters/bulk',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @returns OnboardingPeriodBenefitsDto
   * @throws ApiError
   */
  public benefitsControllerGetEmployeeBenefits(
    employeeId: string
  ): CancelablePromise<OnboardingPeriodBenefitsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/active/benefits',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns OnboardingPeriodBenefitsDto
   * @throws ApiError
   */
  public benefitsControllerGetAllEmployeeOnboardingPeriodBenefits(
    employeeId: string
  ): CancelablePromise<Array<OnboardingPeriodBenefitsDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/all/benefits',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns OnboardingPeriodBenefitsDto
   * @throws ApiError
   */
  public benefitsControllerGetRenewableOnboardingPeriodBenefits(
    employeeId: string
  ): CancelablePromise<OnboardingPeriodBenefitsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/renewable-benefits',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param periodId
   * @returns OnboardingPeriodBenefitsDto
   * @throws ApiError
   */
  public benefitsControllerGetBenefits(
    periodId: string
  ): CancelablePromise<OnboardingPeriodBenefitsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/benefits',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param openEnrollmentPeriodId
   * @returns BenefitDto
   * @throws ApiError
   */
  public benefitsControllerGetOpenEnrollmentPeriodBenefits(
    openEnrollmentPeriodId: string
  ): CancelablePromise<Array<BenefitDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/open-enrollment-periods/{openEnrollmentPeriodId}/benefits',
      path: {
        openEnrollmentPeriodId: openEnrollmentPeriodId,
      },
    });
  }
  /**
   * Update benefit status
   * Updates the status of a benefit. `IN_CART` is not a valid value. Not intended for submissions (cart → READY_TO_APPLY / AWAITING_MEDICAL).
   * @param benefitId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerUpdateBenefitStatus(
    benefitId: string,
    idempotencyKey: string,
    requestBody: UpdateBenefitStatusDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/benefits/{benefitId}/status',
      path: {
        benefitId: benefitId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param benefitId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerUpdateApplicationSubmissionMethod(
    benefitId: string,
    requestBody: UpdateApplicationSubmissionMethodDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/benefits/{benefitId}/application-submission-method',
      path: {
        benefitId: benefitId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns BenefitDto
   * @throws ApiError
   */
  public benefitsControllerAddBenefitPlanToCart(
    periodId: string,
    requestBody: AddBenefitToCartDto
  ): CancelablePromise<Array<BenefitDto>> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/onboarding-periods/{periodId}/benefits/cart',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns BenefitsRequiringStatusUpdateDto
   * @throws ApiError
   */
  public benefitsControllerGetBenefitsRequiringStatusUpdate(): CancelablePromise<BenefitsRequiringStatusUpdateDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/benefits/requiring-status-update',
    });
  }
  /**
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerReportBenefitStatusMismatches(): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/benefits/status-mismatches/report',
    });
  }
  /**
   * @param benefitId
   * @returns BenefitDto
   * @throws ApiError
   */
  public benefitsControllerGetBenefit(
    benefitId: string
  ): CancelablePromise<BenefitDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/benefits/{benefitId}',
      path: {
        benefitId: benefitId,
      },
    });
  }
  /**
   * @param benefitId
   * @param idempotencyKey
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerDeleteBenefit(
    benefitId: string,
    idempotencyKey: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/benefits/{benefitId}',
      path: {
        benefitId: benefitId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
    });
  }
  /**
   * @param benefitId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerUpdateBenefitPremium(
    benefitId: string,
    idempotencyKey: string,
    requestBody: UpdateBenefitPremiumDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/benefits/{benefitId}/premium',
      path: {
        benefitId: benefitId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param benefitId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerUpdateSubmittedPlan(
    benefitId: string,
    idempotencyKey: string,
    requestBody: UpdateSubmittedPlanDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/benefits/{benefitId}/submitted-plan',
      path: {
        benefitId: benefitId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param benefitId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerUpdateBenefitSelfPay(
    benefitId: string,
    idempotencyKey: string,
    requestBody: UpdateBenefitSelfPayDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/benefits/{benefitId}/self-pay',
      path: {
        benefitId: benefitId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param benefitId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerUpdateAorConfirmedByEmployee(
    benefitId: string,
    requestBody: UpdateAorConfirmedByEmployeeDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/benefits/{benefitId}/aor-confirmed-by-employee',
      path: {
        benefitId: benefitId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param benefitId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerUpdatePaymentStatus(
    benefitId: string,
    requestBody: UpdateBenefitPaymentStatusDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/benefits/{benefitId}/payment-status',
      path: {
        benefitId: benefitId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param benefitId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerUpdatePaymentMethodOverride(
    benefitId: string,
    requestBody: UpdateBenefitPaymentMethodOverrideDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/benefits/{benefitId}/payment-method-override',
      path: {
        benefitId: benefitId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param benefitId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerAssignEnrollmentAgent(
    benefitId: string,
    requestBody: AssignBenefitEnrollmentAgentDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/benefits/{benefitId}/assign-enrollment-agent',
      path: {
        benefitId: benefitId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param benefitId
   * @param idempotencyKey
   * @returns void
   * @throws ApiError
   */
  public benefitsControllerInitiateFunding(
    benefitId: string,
    idempotencyKey: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/benefits/{benefitId}/initiate-funding',
      path: {
        benefitId: benefitId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
    });
  }
  /**
   * @param periodId
   * @returns CarePreferencesDto
   * @throws ApiError
   */
  public carePreferencesControllerGetCarePreferences(
    periodId: string
  ): CancelablePromise<CarePreferencesDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/care-preferences',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @returns ProviderPreferenceDto
   * @throws ApiError
   */
  public carePreferencesControllerGetProviderPreferences(
    periodId: string
  ): CancelablePromise<Array<ProviderPreferenceDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/care-preferences/providers',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public carePreferencesControllerUpdateProviderPreferences(
    periodId: string,
    requestBody: Array<ProviderPreferenceDto>
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/onboarding-periods/{periodId}/care-preferences/providers',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public carePreferencesControllerUpdateDecisionFactors(
    periodId: string,
    requestBody: UpdateDecisionFactorsDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/onboarding-periods/{periodId}/care-preferences/decision-factors',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @returns DrugDto
   * @throws ApiError
   */
  public carePreferencesControllerGetDrugPreferences(
    periodId: string
  ): CancelablePromise<Array<DrugDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/care-preferences/drugs',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public carePreferencesControllerUpdateDrugPreferences(
    periodId: string,
    requestBody: Array<DrugDto>
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/onboarding-periods/{periodId}/care-preferences/drugs',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public carePreferencesControllerUpdateFinancialRiskTolerance(
    periodId: string,
    requestBody: FinancialRiskToleranceDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/onboarding-periods/{periodId}/care-preferences/financial-risk-tolerance',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public carePreferencesControllerUpdateCostPreferences(
    periodId: string,
    requestBody: Array<CostPreferenceDto>
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/onboarding-periods/{periodId}/care-preferences/cost-preferences',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param employeeId
   * @param radius The search radius in miles (max 200). Defaults to 20 miles if not provided.
   * @param zipCode The zip code to search providers in (exactly 5 characters). Falls back to employee zip code if not provided.
   * @param specialtyCategoryIds The specialty category IDs to filter providers by
   * @param searchTerm The search term to use when searching for providers
   * @param type The entity type of the provider
   * @returns MajorMedicalProvider
   * @throws ApiError
   */
  public carePreferencesControllerSearchProviders(
    periodId: string,
    employeeId: string,
    radius?: number,
    zipCode?: string,
    specialtyCategoryIds?: Array<string>,
    searchTerm?: string,
    type?: string
  ): CancelablePromise<Array<MajorMedicalProvider>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employee/{employeeId}/onboarding-periods/{periodId}/care-preferences/search-providers',
      path: {
        periodId: periodId,
        employeeId: employeeId,
      },
      query: {
        radius: radius,
        zipCode: zipCode,
        specialtyCategoryIds: specialtyCategoryIds,
        searchTerm: searchTerm,
        type: type,
      },
    });
  }
  /**
   * @param employeeId
   * @param familyUnit
   * @param numberOfDependents Number of child dependents on the plan. Must be >= 1 for FAMILY or EMPLOYEE_CHILD; any non-negative integer for EMPLOYEE_ONLY or EMPLOYEE_SPOUSE.
   * @returns EmployerContributionDto
   * @throws ApiError
   */
  public contributionModelsControllerFindEmployerContributionForEmployee(
    employeeId: string,
    familyUnit?: FamilyUnit,
    numberOfDependents?: number
  ): CancelablePromise<EmployerContributionDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/active/employer-contribution',
      path: {
        employeeId: employeeId,
      },
      query: {
        familyUnit: familyUnit,
        numberOfDependents: numberOfDependents,
      },
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns EmployerContributionDto
   * @throws ApiError
   */
  public contributionModelsControllerFindEmployerContributionForEmployeeByInsuredIds(
    employeeId: string,
    requestBody: GetEmployerContributionByInsuredIdsDto
  ): CancelablePromise<EmployerContributionDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/active/employer-contribution',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param familyUnit
   * @param numberOfDependents Number of child dependents on the plan. Must be >= 1 for FAMILY or EMPLOYEE_CHILD; any non-negative integer for EMPLOYEE_ONLY or EMPLOYEE_SPOUSE.
   * @returns EmployerContributionDto
   * @throws ApiError
   */
  public contributionModelsControllerFindEmployeesEmployerContribution(
    periodId: string,
    familyUnit?: FamilyUnit,
    numberOfDependents?: number
  ): CancelablePromise<EmployerContributionDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/employer-contribution',
      path: {
        periodId: periodId,
      },
      query: {
        familyUnit: familyUnit,
        numberOfDependents: numberOfDependents,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns EmployerContributionDto
   * @throws ApiError
   */
  public contributionModelsControllerFindEmployeesEmployerContributionByInsuredIds(
    periodId: string,
    requestBody: GetEmployerContributionByInsuredIdsDto
  ): CancelablePromise<EmployerContributionDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/employer-contribution',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @returns PossibleEmployerContributionDto
   * @throws ApiError
   */
  public contributionModelsControllerFindPossibleEmployerContributions(
    employeeId: string
  ): CancelablePromise<Array<PossibleEmployerContributionDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/possible-employer-contributions',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param periodId
   * @returns PossibleEmployerContributionDto
   * @throws ApiError
   */
  public contributionModelsControllerFindPossibleEmployerContributionsByAnyPeriod(
    periodId: string
  ): CancelablePromise<Array<PossibleEmployerContributionDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/possible-employer-contributions',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns SupplementalPlanForEnrollment
   * @throws ApiError
   */
  public dentalControllerSearch(
    periodId: string,
    requestBody: SupplementalPlanSearchRequest
  ): CancelablePromise<Array<SupplementalPlanForEnrollment>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/dental/search',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns EnrollmentActivityLogDto
   * @throws ApiError
   */
  public enrollmentActivityLogControllerCreate(
    periodId: string,
    requestBody: CreateEnrollmentActivityLogRequestDto
  ): CancelablePromise<EnrollmentActivityLogDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/enrollment-activity-logs',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @returns EnrollmentActivityLogGroupDto
   * @throws ApiError
   */
  public enrollmentActivityLogControllerFindMany(
    periodId: string
  ): CancelablePromise<Array<EnrollmentActivityLogGroupDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/enrollment-activity-logs',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public enrollmentActivityLogControllerCreateMany(
    periodId: string,
    requestBody: Array<CreateEnrollmentActivityLogRequestDto>
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/enrollment-activity-logs/create-many',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @returns EnrollmentActivityLogGroupDto
   * @throws ApiError
   */
  public enrollmentActivityLogControllerFindManyForEmployerAdmin(
    periodId: string
  ): CancelablePromise<Array<EnrollmentActivityLogGroupDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/enrollment-activity-logs/employer-admin',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @returns void
   * @throws ApiError
   */
  public enrollmentCommunicationsControllerSendEnrollmentConfirmationEmail(
    periodId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/enrollment-confirmation/email',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @returns void
   * @throws ApiError
   */
  public enrollmentCommunicationsControllerSendSummaryEmail(
    periodId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/summary/email',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @returns void
   * @throws ApiError
   */
  public enrollmentCommunicationsControllerSendElectionWindowLaunchEmail(
    periodId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/election-window-launch/email',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @returns void
   * @throws ApiError
   */
  public enrollmentCommunicationsControllerSendElectionReminder(
    periodId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/election-reminder/email',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns void
   * @throws ApiError
   */
  public enrollmentCommunicationsControllerSendWaiverConfirmation(
    employeeId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/waiver-confirmation/email',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public enrollmentCommunicationsControllerSendCarrierApplicationEmail(
    periodId: string,
    requestBody?: EnrollmentEmailPaymentOptionsDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/carrier-application/email',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param employerId
   * @returns CommunicationDisplayConditionsDto
   * @throws ApiError
   */
  public enrollmentCommunicationsControllerGetEnrollmentCommunicationConditions(
    periodId: string,
    employerId: string
  ): CancelablePromise<CommunicationDisplayConditionsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/communication-conditions',
      path: {
        periodId: periodId,
      },
      query: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns InsuredPeopleDto
   * @throws ApiError
   */
  public insuredControllerFindInsuredForEmployee(
    employeeId: string
  ): CancelablePromise<InsuredPeopleDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/active/insured',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public insuredControllerUpdateAnticipatedCareLevels(
    employeeId: string,
    requestBody: UpdateAnticipatedCareLevelsDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employees/{employeeId}/onboarding-periods/active/insured/care-levels',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns string
   * @throws ApiError
   */
  public insuredControllerUpsertInsuredForPeriod(
    periodId: string,
    requestBody: UpsertInsuredPeopleDto
  ): CancelablePromise<Array<string>> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employees/{employeeId}/onboarding-periods/{periodId}/insured',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @returns InsuredPeopleDto
   * @throws ApiError
   */
  public insuredControllerFindInsuredForPeriod(
    periodId: string
  ): CancelablePromise<InsuredPeopleDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/{periodId}/insured',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public insuredControllerUpdateCustomClassCategory(
    periodId: string,
    requestBody: UpdateCustomClassCategoryDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employees/{employeeId}/onboarding-periods/{periodId}/insured/class-category',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public insuredControllerNotifySelectedDependents(
    periodId: string,
    requestBody: SelectedDependentsDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employees/{employeeId}/onboarding-periods/{periodId}/discovery/selected-dependents',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns MajorMedicalCarrierDto
   * @throws ApiError
   */
  public majorMedicalCarriersControllerGetCarriers(): CancelablePromise<
    Array<MajorMedicalCarrierDto>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/major-medical-carriers',
    });
  }
  /**
   * @param state
   * @param name
   * @returns MajorMedicalCarrierDto
   * @throws ApiError
   */
  public majorMedicalCarriersControllerFindByNameAndState(
    state: USState,
    name: string
  ): CancelablePromise<MajorMedicalCarrierDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/major-medical-carriers/by-name-and-state',
      query: {
        state: state,
        name: name,
      },
    });
  }
  /**
   * @param requestBody
   * @returns MajorMedicalCarrierDto
   * @throws ApiError
   */
  public majorMedicalCarriersControllerSearchCarriers(
    requestBody: SearchMajorMedicalCarriersPayloadDto
  ): CancelablePromise<Array<MajorMedicalCarrierDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/major-medical-carriers/search',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns UpdateMajorMedicalCarriersResponseDto
   * @throws ApiError
   */
  public majorMedicalCarriersControllerUpdateMedicalCarriers(
    requestBody: Array<UpdateMajorMedicalCarriersDto>
  ): CancelablePromise<UpdateMajorMedicalCarriersResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/major-medical-carriers/update-carriers',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param planYear
   * @param requestBody A list of zip codes
   * @returns PlanIssuerDto
   * @throws ApiError
   */
  public majorMedicalCarriersControllerGetCarrierPlans(
    planYear: number,
    requestBody: Array<number>
  ): CancelablePromise<Array<PlanIssuerDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/major-medical-carriers/plans/{planYear}',
      path: {
        planYear: planYear,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param benefitId
   * @param idempotencyKey
   * @param requestBody
   * @returns EnrollmentConfirmationResultDto
   * @throws ApiError
   */
  public majorMedicalControllerConfirmEnrollment(
    benefitId: string,
    idempotencyKey: string,
    requestBody: EnrollmentConfirmationDto
  ): CancelablePromise<EnrollmentConfirmationResultDto> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employees/{employeeId}/onboarding-periods/major-medical-plan/{benefitId}/confirm',
      path: {
        benefitId: benefitId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns MedicalPlanForEnrollment
   * @throws ApiError
   */
  public majorMedicalControllerSearchMedicalPlansForEmployee(
    employeeId: string,
    requestBody: PlanSearchSelfDto
  ): CancelablePromise<Array<MedicalPlanForEnrollment>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/active/major-medical-plans',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param periodId
   * @param requestBody
   * @returns DiscoveryPlanSearchResponseDto
   * @throws ApiError
   */
  public majorMedicalControllerSearchDiscoveryMedicalPlansForOnboardingPeriod(
    employeeId: string,
    periodId: string,
    requestBody: DiscoveryPlanSearchRequestDto
  ): CancelablePromise<DiscoveryPlanSearchResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/{periodId}/major-medical-plans/discovery',
      path: {
        employeeId: employeeId,
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns MedicalPlanForEnrollment
   * @throws ApiError
   */
  public majorMedicalControllerSearchMedicalPlansForOnboardingPeriod(
    periodId: string,
    requestBody: PlanSearchSelfDto
  ): CancelablePromise<Array<MedicalPlanForEnrollment>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/{periodId}/major-medical-plans',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param onboardingPeriodId
   * @returns GetPlanSearchModeDto
   * @throws ApiError
   */
  public majorMedicalControllerGetPlanSearchMode(
    employeeId: string,
    onboardingPeriodId: string
  ): CancelablePromise<GetPlanSearchModeDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/active/major-medical-plans/search-mode',
      path: {
        employeeId: employeeId,
      },
      query: {
        onboardingPeriodId: onboardingPeriodId,
      },
    });
  }
  /**
   * @param benefitId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public majorMedicalControllerPatchMajorMedicalPlan(
    benefitId: string,
    requestBody: PatchMajorMedicalPlanDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/employees/{employeeId}/onboarding-periods/major-medical-plan/{benefitId}',
      path: {
        benefitId: benefitId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @returns ElectionReviewSnapshotDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerCreateElectionReviewSnapshot(
    periodId: string
  ): CancelablePromise<ElectionReviewSnapshotDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/election-review-snapshots',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @returns ManualElectionReviewSnapshotDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerCreateManualElectionReviewSnapshot(
    periodId: string
  ): CancelablePromise<ManualElectionReviewSnapshotDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/manual-election-review-snapshots',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns RenewalReviewSnapshotDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerCreateRenewalReviewSnapshot(
    periodId: string,
    requestBody: CreateRenewalReviewSnapshotDto
  ): CancelablePromise<RenewalReviewSnapshotDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/renewal-review-snapshots',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns OnboardingPeriodDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerCreate(
    requestBody: CreateOnboardingPeriodByAdminDto
  ): CancelablePromise<OnboardingPeriodDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns OnboardingPeriodDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerCreateByEmployee(
    employeeId: string,
    requestBody: CreateOnboardingPeriodByEmployeeDto
  ): CancelablePromise<OnboardingPeriodDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/createByEmployee',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @returns OnboardingPeriodDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerFindActivePeriod(
    employeeId: string
  ): CancelablePromise<OnboardingPeriodDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/active',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param periodId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerSubmitBenefitsElection(
    periodId: string,
    idempotencyKey: string,
    requestBody: SubmitElectionDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/onboarding-periods/{periodId}/submit-election',
      path: {
        periodId: periodId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerSubmitSelfReportElection(
    periodId: string,
    idempotencyKey: string,
    requestBody: SubmitSelfReportElectionDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/onboarding-periods/{periodId}/self-report-election',
      path: {
        periodId: periodId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerUpdateByAdmin(
    periodId: string,
    idempotencyKey: string,
    requestBody: UpdateOnboardingPeriodByAdminDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/onboarding-periods/{periodId}',
      path: {
        periodId: periodId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param idempotencyKey
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerDelete(
    periodId: string,
    idempotencyKey: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/onboarding-periods/{periodId}',
      path: {
        periodId: periodId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerOverrideAllowance(
    periodId: string,
    requestBody: UpdateOnboardingPeriodAllowanceDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/onboarding-periods/{periodId}/override-allowance',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param periodId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerUpdateEffectiveDates(
    employeeId: string,
    periodId: string,
    idempotencyKey: string,
    requestBody: DateRangeDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/employees/{employeeId}/onboarding-periods/{periodId}/update-effective-dates',
      path: {
        employeeId: employeeId,
        periodId: periodId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @returns LastSubmittedPeriodIdDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerGetLastSubmittedPeriodId(
    employeeId: string
  ): CancelablePromise<LastSubmittedPeriodIdDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/last-submitted-id',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @param periodId
   * @returns OnboardingPeriodDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerFindOne(
    employeeId: string,
    periodId: string
  ): CancelablePromise<OnboardingPeriodDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/{periodId}',
      path: {
        employeeId: employeeId,
        periodId: periodId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns OnboardingPeriodDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerFindMany(
    employeeId: string
  ): CancelablePromise<Array<OnboardingPeriodDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns OnboardingPeriodWithEnrollmentStatusDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerFindManyWithEnrollmentStatus(
    employeeId: string
  ): CancelablePromise<Array<OnboardingPeriodWithEnrollmentStatusDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods-with-enrollment-status',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerUpdateMyLastLogin(
    employeeId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/employees/{employeeId}/onboarding-periods/active/userLogin',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public onboardingPeriodsControllerRecomputeStatuses(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/onboarding-periods/status/recompute',
    });
  }
  /**
   * @param idempotencyKey
   * @returns any
   * @throws ApiError
   */
  public onboardingPeriodsControllerAutoWaiveOrRemoveExpiredOnboardingPeriods(
    idempotencyKey: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/auto-waive-or-remove-expired',
      headers: {
        'idempotency-key': idempotencyKey,
      },
    });
  }
  /**
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerNotifyEnrollmentTeamAssignment(
    requestBody: NotifyEnrollmentTeamAssignmentDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/notify-enrollment-team-assignment',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerCreateEnrollmentComment(
    periodId: string,
    requestBody: CreateEnrollmentCommentDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/enrollment-comments',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @returns EnrollmentCommentDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerFindManyEnrollmentComments(
    periodId: string
  ): CancelablePromise<Array<EnrollmentCommentDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/enrollment-comments',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param commentId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerUpdateEnrollmentComment(
    commentId: string,
    requestBody: UpdateEnrollmentCommentDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/onboarding-periods/{periodId}/enrollment-comments/{commentId}',
      path: {
        commentId: commentId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param commentId
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerDeleteEnrollmentComment(
    commentId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/onboarding-periods/{periodId}/enrollment-comments/{commentId}',
      path: {
        commentId: commentId,
      },
    });
  }
  /**
   * @param oepId
   * @returns OnboardingPeriodDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerFindPeriodsByOpenEnrollmentPeriod(
    oepId: string
  ): CancelablePromise<Array<OnboardingPeriodDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/open-enrollment-periods/{oepId}/onboarding-periods',
      path: {
        oepId: oepId,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerAssignEnrollmentTeam(
    periodId: string,
    requestBody: AssignEnrollmentTeamDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/onboarding-periods/{periodId}/assign-enrollment-team',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerUpdateEnrollmentTags(
    periodId: string,
    requestBody: UpdateEnrollmentTagsDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/onboarding-periods/{periodId}/update-enrollment-tags',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerLogEnrollmentCall(
    periodId: string,
    requestBody: LogEnrollmentCallDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/log-enrollment-call',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns OnboardingPeriodDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerFindManyPeriods(
    requestBody: FindManyOnboardingPeriodsDto
  ): CancelablePromise<Array<OnboardingPeriodDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/find-many',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param totalAllowance
   * @returns EnrollmentReviewBenefitItemsDto
   * @throws ApiError
   */
  public onboardingPeriodsControllerGetEnrollmentReviewForSubmission(
    periodId: string,
    totalAllowance: number
  ): CancelablePromise<EnrollmentReviewBenefitItemsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/enrollment-review',
      path: {
        periodId: periodId,
      },
      query: {
        totalAllowance: totalAllowance,
      },
    });
  }
  /**
   * @param periodId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerWaiveCoverage(
    periodId: string,
    idempotencyKey: string,
    requestBody: WaiveCoverageDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/waive-coverage',
      path: {
        periodId: periodId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param idempotencyKey
   * @param shouldReturnBenefitsToCart
   * @returns void
   * @throws ApiError
   */
  public onboardingPeriodsControllerResetBenefitsElection(
    periodId: string,
    idempotencyKey: string,
    shouldReturnBenefitsToCart: boolean
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/onboarding-periods/{periodId}/benefits-election-reset',
      path: {
        periodId: periodId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      query: {
        shouldReturnBenefitsToCart: shouldReturnBenefitsToCart,
      },
    });
  }
  /**
   * @param employerId
   * @param employeeId
   * @param requestBody
   * @returns PriorVendorBenefitDto
   * @throws ApiError
   */
  public priorVendorBenefitsControllerUpsert(
    employerId: string,
    employeeId: string,
    requestBody: UpsertPriorVendorBenefitDto
  ): CancelablePromise<PriorVendorBenefitDto> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employers/{employerId}/employees/{employeeId}/prior-vendor-benefit',
      path: {
        employerId: employerId,
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @param employeeId
   * @param year
   * @param benefitType
   * @returns void
   * @throws ApiError
   */
  public priorVendorBenefitsControllerDelete(
    employerId: string,
    employeeId: string,
    year: number,
    benefitType: BenefitType
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/employers/{employerId}/employees/{employeeId}/prior-vendor-benefit',
      path: {
        employerId: employerId,
        employeeId: employeeId,
      },
      query: {
        year: year,
        benefitType: benefitType,
      },
    });
  }
  /**
   * @param periodId
   * @returns RenewalDto
   * @throws ApiError
   */
  public renewalControllerGetRenewal(
    periodId: string
  ): CancelablePromise<RenewalDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/renewal',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns PlanSummaryDto
   * @throws ApiError
   */
  public renewalControllerPriceForMembers(
    periodId: string,
    requestBody: RenewalPriceRequestDto
  ): CancelablePromise<PlanSummaryDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/renewal/price',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns SavedPlanDto
   * @throws ApiError
   */
  public savedPlanControllerCreate(
    periodId: string,
    requestBody: CreateSavedPlanRequestDto
  ): CancelablePromise<SavedPlanDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/major-medical-plans/{periodId}/saved-plans',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @returns SavedPlanDto
   * @throws ApiError
   */
  public savedPlanControllerFindMany(
    periodId: string
  ): CancelablePromise<Array<SavedPlanDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/major-medical-plans/{periodId}/find-many',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param planId Plan ID
   * @param periodId Onboarding period ID
   * @returns void
   * @throws ApiError
   */
  public savedPlanControllerDelete(
    planId: string,
    periodId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/major-medical-plans/{periodId}/saved-plans/{planId}',
      path: {
        planId: planId,
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @param requestBody
   * @returns SupplementalPlanForEnrollment
   * @throws ApiError
   */
  public visionControllerSearch(
    periodId: string,
    requestBody: SupplementalPlanSearchRequest
  ): CancelablePromise<Array<SupplementalPlanForEnrollment>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/onboarding-periods/{periodId}/vision/search',
      path: {
        periodId: periodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns CarrierContextIssuesDto Computed on each call from the read replica, so a fix shows up once the replica has caught up
   * @throws ApiError
   */
  public carrierContextAdminControllerFindIssues(): CancelablePromise<CarrierContextIssuesDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/carrier-context/admin/issues',
    });
  }
  /**
   * @returns CarrierRowsDto Each carrier and state: the legacy rows the migration match pairs with it next to its carrier_context row, value by value. Computed on each call from the read replica
   * @throws ApiError
   */
  public carrierContextAdminControllerFindCarriers(): CancelablePromise<CarrierRowsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/carrier-context/admin/carriers',
    });
  }
  /**
   * @param cursor The nextCursor of the previous page; omit for the first page
   * @param limit How many benefits to compare
   * @returns CarrierContextComparisonPageDto One page of benefits compared field by field between the legacy carrier tables and carrier_context; fetch pages until nextCursor is null
   * @throws ApiError
   */
  public carrierContextAdminControllerCompareCarrierContext(
    cursor?: string,
    limit: number = 200
  ): CancelablePromise<CarrierContextComparisonPageDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/carrier-context/admin/comparison',
      query: {
        cursor: cursor,
        limit: limit,
      },
    });
  }
  /**
   * @param requestBody
   * @returns EmployeeDto
   * @throws ApiError
   */
  public employeesControllerCreate(
    requestBody: CreateEmployeeDto
  ): CancelablePromise<EmployeeDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @returns EmployeeDto
   * @throws ApiError
   */
  public employeesControllerFindAll(
    employerId: string
  ): CancelablePromise<Array<EmployeeDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees',
      query: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param requestBody
   * @returns UpsertManyEmployeesResult
   * @throws ApiError
   */
  public employeesControllerUpsertMany(
    requestBody: UpsertManyEmployeesRequest
  ): CancelablePromise<UpsertManyEmployeesResult> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/upsertMany',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns EmployeeDto
   * @throws ApiError
   */
  public employeesControllerUpsert(
    requestBody: CreateEmployeeDto
  ): CancelablePromise<EmployeeDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/upsert',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @param requestBody
   * @returns EmployeeDto
   * @throws ApiError
   */
  public employeesControllerFindMany(
    employerId: string,
    requestBody: Array<string>
  ): CancelablePromise<Array<EmployeeDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/find-many',
      query: {
        employerId: employerId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns EmployeeCount
   * @throws ApiError
   */
  public employeesControllerCount(): CancelablePromise<Array<EmployeeCount>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/count',
    });
  }
  /**
   * @param employerId
   * @returns number
   * @throws ApiError
   */
  public employeesControllerCountByEmployer(
    employerId: string
  ): CancelablePromise<number> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/count-by-employer',
      query: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public employeesControllerUpdateEmployeeInfo(
    employeeId: string,
    requestBody: UpdateEmployeeInfoDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employees/{employeeId}/info',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @returns EmployeeInfoDto
   * @throws ApiError
   */
  public employeesControllerGetEmployeeInfo(
    employeeId: string
  ): CancelablePromise<EmployeeInfoDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/info',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns EmployeeDto
   * @throws ApiError
   */
  public employeesControllerFindOne(
    employeeId: string
  ): CancelablePromise<EmployeeDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns void
   * @throws ApiError
   */
  public employeesControllerDelete(
    employeeId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/employees/{employeeId}',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param userId
   * @returns EmployeeDto
   * @throws ApiError
   */
  public employeesControllerFindEmployeeByUserId(
    userId: string
  ): CancelablePromise<EmployeeDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/find-user-by-id/{userId}',
      path: {
        userId: userId,
      },
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public employeesControllerUpdateSelf(
    employeeId: string,
    requestBody: UpdateEmployeeDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/employees/{employeeId}/update-self',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public employeesControllerUpdateByAdmin(
    employeeId: string,
    requestBody: UpdateEmployeeDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/employees/{employeeId}/update-by-admin',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public employeesControllerUpdateEligibility(
    employeeId: string,
    idempotencyKey: string,
    requestBody: UpdateEligibilityDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/employees/{employeeId}/update-eligibility',
      path: {
        employeeId: employeeId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @returns boolean
   * @throws ApiError
   */
  public employeesControllerHasPreviousEligibility(
    employeeId: string
  ): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/has-previous-eligibility',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public employeesControllerSetLeaveOfAbsence(
    employeeId: string,
    requestBody: LeaveOfAbsenceDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/employees/{employeeId}/leave-of-absence',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public employeesControllerTerminateEmployee(
    employeeId: string,
    idempotencyKey: string,
    requestBody: TerminateEmployeeDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/employees/{employeeId}/terminate',
      path: {
        employeeId: employeeId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public employeesControllerSendCobraEmails(
    requestBody: SendCobraEmailsRequestDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/send-cobra-emails',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns CompanyEmailInUseDto
   * @throws ApiError
   */
  public employeesControllerCheckCompanyEmailExists(
    requestBody: EmailDto
  ): CancelablePromise<CompanyEmailInUseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/available-company-emails',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public employeesControllerUpdateCompanyEmail(
    employeeId: string,
    requestBody: EmailDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employees/{employeeId}/company-email',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @returns DependentsDtoResult
   * @throws ApiError
   */
  public employeesControllerGetDependents(
    employeeId: string
  ): CancelablePromise<DependentsDtoResult> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/dependents',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns DependentsDtoResult
   * @throws ApiError
   */
  public employeesControllerUpsertDependents(
    employeeId: string,
    requestBody: UpsertDependentsDto
  ): CancelablePromise<DependentsDtoResult> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employees/{employeeId}/dependents',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Create a new workflow execution
   * @param requestBody
   * @returns CreateWorkflowResponseDto Workflow created and queued for execution
   * @throws ApiError
   */
  public workflowAdminControllerCreate(
    requestBody: CreateWorkflowRequestDto
  ): CancelablePromise<CreateWorkflowResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/admin/workflows',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * List recent workflow executions for the admin dashboard
   * @param statuses
   * @param workflowType
   * @param correlationId Exact correlation ID match; non-matching returns empty
   * @returns ListWorkflowsResponseDto Recent workflow executions within the fixed window
   * @throws ApiError
   */
  public workflowAdminControllerList(
    statuses?: Array<WorkflowStatus>,
    workflowType?: string,
    correlationId?: string
  ): CancelablePromise<ListWorkflowsResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/admin/workflows',
      query: {
        statuses: statuses,
        workflowType: workflowType,
        correlationId: correlationId,
      },
    });
  }
  /**
   * Trigger immediate execution of a pending workflow
   * @param workflowId Workflow execution ID
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public workflowAdminControllerTrigger(
    workflowId: string,
    requestBody: TriggerWorkflowDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/admin/workflows/{workflowId}/trigger',
      path: {
        workflowId: workflowId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Status breakdown for the dashboard summary cards
   * @param statuses
   * @param workflowType
   * @param correlationId Exact correlation ID match
   * @returns WorkflowStatsResponseDto Counts by status within the window, ignoring the status filter
   * @throws ApiError
   */
  public workflowAdminControllerStats(
    statuses?: Array<WorkflowStatus>,
    workflowType?: string,
    correlationId?: string
  ): CancelablePromise<WorkflowStatsResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/admin/workflows/stats',
      query: {
        statuses: statuses,
        workflowType: workflowType,
        correlationId: correlationId,
      },
    });
  }
  /**
   * Distinct workflow types for the type filter autocomplete
   * @returns WorkflowTypesResponseDto Distinct workflow types seen within the window
   * @throws ApiError
   */
  public workflowAdminControllerTypes(): CancelablePromise<WorkflowTypesResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/admin/workflows/types',
    });
  }
  /**
   * Workflow execution metadata for the detail view
   * @param workflowId Workflow execution ID
   * @returns WorkflowExecutionDto Workflow execution metadata (no tasks inline)
   * @throws ApiError
   */
  public workflowAdminControllerGetById(
    workflowId: string
  ): CancelablePromise<WorkflowExecutionDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/admin/workflows/{workflowId}',
      path: {
        workflowId: workflowId,
      },
    });
  }
  /**
   * All tasks for a workflow, in execution order, errors inline
   * @param workflowId Workflow execution ID
   * @param status
   * @returns ListTasksResponseDto Tasks ordered by sequence number, each with its errors
   * @throws ApiError
   */
  public workflowAdminControllerGetTasks(
    workflowId: string,
    status?: 'PENDING' | 'DEFERRED' | 'RUNNING' | 'COMPLETED' | 'FAILED'
  ): CancelablePromise<ListTasksResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/admin/workflows/{workflowId}/tasks',
      path: {
        workflowId: workflowId,
      },
      query: {
        status: status,
      },
    });
  }
  /**
   * A single task with its full payload, result and errors
   * @param workflowId Workflow execution ID
   * @param taskId Workflow task ID
   * @returns TaskWithErrorsDto Task detail including payload and result
   * @throws ApiError
   */
  public workflowAdminControllerGetTask(
    workflowId: string,
    taskId: string
  ): CancelablePromise<TaskWithErrorsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/admin/workflows/{workflowId}/tasks/{taskId}',
      path: {
        workflowId: workflowId,
        taskId: taskId,
      },
    });
  }
  /**
   * Resume a FAILED or CANCELLED workflow in place
   * @param workflowId Workflow execution ID
   * @param requestBody
   * @returns ResumeWorkflowResponseDto Workflow resume accepted; orchestrator queued asynchronously
   * @throws ApiError
   */
  public workflowAdminControllerResume(
    workflowId: string,
    requestBody: ResumeWorkflowDto
  ): CancelablePromise<ResumeWorkflowResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/admin/workflows/{workflowId}/resume',
      path: {
        workflowId: workflowId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Stop a RUNNING or PENDING workflow (marks CANCELLED)
   * @param workflowId Workflow execution ID
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public workflowAdminControllerStop(
    workflowId: string,
    requestBody: StopWorkflowDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/admin/workflows/{workflowId}/stop',
      path: {
        workflowId: workflowId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get workflow execution status
   * @param workflowId Workflow execution ID
   * @returns WorkflowExecutionDto Workflow status retrieved
   * @throws ApiError
   */
  public workflowsControllerGetStatus(
    workflowId: string
  ): CancelablePromise<WorkflowExecutionDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/workflows/{workflowId}',
      path: {
        workflowId: workflowId,
      },
    });
  }
  /**
   * Get workflow by correlation ID
   * @param correlationId Correlation ID
   * @returns WorkflowExecutionDto Workflow found
   * @throws ApiError
   */
  public workflowsControllerGetByCorrelationId(
    correlationId: string
  ): CancelablePromise<WorkflowExecutionDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/workflows/by-correlation/{correlationId}',
      path: {
        correlationId: correlationId,
      },
    });
  }
  /**
   * Get workflow execution report by correlation ID
   * @param correlationId Correlation ID
   * @returns WorkflowExecutionReportDto Workflow execution report
   * @throws ApiError
   */
  public workflowsControllerGetReportByCorrelationId(
    correlationId: string
  ): CancelablePromise<WorkflowExecutionReportDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/workflows/by-correlation/{correlationId}/report',
      path: {
        correlationId: correlationId,
      },
    });
  }
  /**
   * Execute a workflow task (internal use only)
   * @param requestBody
   * @returns ExecuteTaskResponseDto Task executed
   * @throws ApiError
   */
  public workflowsControllerExecuteTask(
    requestBody: ExecuteTaskRequestDto
  ): CancelablePromise<ExecuteTaskResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/workflows/execute-task',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param benefitId
   * @param templateId
   * @returns string
   * @throws ApiError
   */
  public formsFillerControllerGeneratePdf(
    employeeId: string,
    benefitId: string,
    templateId: string
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/forms-filler/generate-pdf',
      query: {
        employeeId: employeeId,
        benefitId: benefitId,
        templateId: templateId,
      },
    });
  }
  /**
   * @returns TemplateDto
   * @throws ApiError
   */
  public formsFillerControllerGetTemplates(): CancelablePromise<
    Array<TemplateDto>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/forms-filler/templates',
    });
  }
  /**
   * @param templateName
   * @param requestBody
   * @returns BulkTemplateDto
   * @throws ApiError
   */
  public formsFillerControllerGenerateBulkEnrollmentCsvData(
    templateName: string,
    requestBody: GenerateCsvDto
  ): CancelablePromise<BulkTemplateDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/forms-filler/generate-bulk-enrollment-csv-data',
      query: {
        templateName: templateName,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns AgencyDto
   * @throws ApiError
   */
  public agenciesControllerCreate(
    requestBody: CreateAgencyDto
  ): CancelablePromise<AgencyDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agencies',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns AllAgenciesDto
   * @throws ApiError
   */
  public agenciesControllerFindAll(): CancelablePromise<AllAgenciesDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/agencies',
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns AgencyDto
   * @throws ApiError
   */
  public agenciesControllerUpdate(
    id: string,
    requestBody: UpdateAgencyDto
  ): CancelablePromise<AgencyDto> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/agencies/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns AgencyDto
   * @throws ApiError
   */
  public agenciesControllerFindOne(id: string): CancelablePromise<AgencyDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/agencies/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns void
   * @throws ApiError
   */
  public agenciesControllerRemove(id: string): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/agencies/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns AllAgenciesDto
   * @throws ApiError
   */
  public agenciesControllerFindAssignableAgencies(
    id: string
  ): CancelablePromise<AllAgenciesDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/agencies/{id}/assignable-agencies',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param employerId
   * @returns EmployerAgenciesDto
   * @throws ApiError
   */
  public agenciesControllerFindMany(
    employerId: string
  ): CancelablePromise<EmployerAgenciesDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/agencies',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param requestBody
   * @returns AgentDto
   * @throws ApiError
   */
  public agentsControllerCreate(
    requestBody: CreateAgentDto
  ): CancelablePromise<AgentDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/agents',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param agencyId
   * @returns AgentDto
   * @throws ApiError
   */
  public agentsControllerFindAllForAgency(
    agencyId: string
  ): CancelablePromise<Array<AgentDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/agents',
      query: {
        agencyId: agencyId,
      },
    });
  }
  /**
   * @param agencyId
   * @returns void
   * @throws ApiError
   */
  public agentsControllerRemoveAllForAgency(
    agencyId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/agents',
      query: {
        agencyId: agencyId,
      },
    });
  }
  /**
   * @param id
   * @returns AgentDto
   * @throws ApiError
   */
  public agentsControllerFindOne(id: string): CancelablePromise<AgentDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/agents/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns AgentDto
   * @throws ApiError
   */
  public agentsControllerUpdate(
    id: string,
    requestBody: UpdateAgentDto
  ): CancelablePromise<AgentDto> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/agents/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns void
   * @throws ApiError
   */
  public agentsControllerRemove(id: string): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/agents/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param requestBody
   * @returns EmployerDto
   * @throws ApiError
   */
  public employersControllerCreate(
    requestBody: CreateEmployerDto
  ): CancelablePromise<EmployerDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employers',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns EmployerSummaryDto
   * @throws ApiError
   */
  public employersControllerFindSummaries(): CancelablePromise<
    Array<EmployerSummaryDto>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/summaries',
    });
  }
  /**
   * @param employerId
   * @returns GetEmployerDto
   * @throws ApiError
   */
  public employersControllerFindOne(
    employerId: string
  ): CancelablePromise<GetEmployerDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @param requestBody
   * @param idempotencyKey
   * @returns EmployerUpdateResponseDto
   * @throws ApiError
   */
  public employersControllerUpdate(
    employerId: string,
    requestBody: UpdateEmployerDto,
    idempotencyKey?: string
  ): CancelablePromise<EmployerUpdateResponseDto> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/employers/{employerId}',
      path: {
        employerId: employerId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @returns void
   * @throws ApiError
   */
  public employersControllerRemove(
    employerId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/employers/{employerId}',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @returns EmployerPublicInfoDto
   * @throws ApiError
   */
  public employersControllerFindEmployerPublicInfo(
    employerId: string
  ): CancelablePromise<EmployerPublicInfoDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/public-info',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @returns string
   * @throws ApiError
   */
  public employersControllerGetSignedLogoUrl(
    employerId: string
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/signed-logo-url',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @param email
   * @param sendInvitationEmail
   * @returns string
   * @throws ApiError
   */
  public employersControllerInviteEmployerAdmin(
    employerId: string,
    email: string,
    sendInvitationEmail: boolean = false
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employers/{employerId}/invite-employer-admin',
      path: {
        employerId: employerId,
      },
      query: {
        email: email,
        sendInvitationEmail: sendInvitationEmail,
      },
    });
  }
  /**
   * @param employerId
   * @returns void
   * @throws ApiError
   */
  public employersControllerCancelInviteEmployerAdmin(
    employerId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/employers/{employerId}/invite-employer-admin',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @param requestBody A list of filters used to exclude plans from search results.
   * @returns void
   * @throws ApiError
   */
  public employersControllerPutMajorMedicalPlanFilters(
    employerId: string,
    requestBody: Array<PlanExclusionFilter>
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employers/{employerId}/major-medical-plans/filters',
      path: {
        employerId: employerId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @returns PlanExclusionFilter
   * @throws ApiError
   */
  public employersControllerGetMajorMedicalPlanFilters(
    employerId: string
  ): CancelablePromise<Array<PlanExclusionFilter>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/major-medical-plans/filters',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @returns EmployerContactsByType
   * @throws ApiError
   */
  public employersControllerGetEmployerContactsByType(
    employerId: string
  ): CancelablePromise<EmployerContactsByType> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/contacts',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public employersControllerUpsertEmployerContacts(
    employerId: string,
    requestBody: Array<CreateEmployerContactDto>
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employers/{employerId}/contacts',
      path: {
        employerId: employerId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @returns void
   * @throws ApiError
   */
  public employersControllerActivateContacts(
    employerId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employers/{employerId}/activate-employer-admin',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @returns EmployerBeneficialOwnerDto
   * @throws ApiError
   */
  public employersControllerGetBeneficialOwners(
    employerId: string
  ): CancelablePromise<Array<EmployerBeneficialOwnerDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/beneficial-owners',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param planExclusionFilterSetId
   * @returns PlanExclusionFilter
   * @throws ApiError
   */
  public employersControllerEmployerFilters(
    planExclusionFilterSetId: string
  ): CancelablePromise<Array<PlanExclusionFilter>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{planExclusionFilterSetId}/filters',
      path: {
        planExclusionFilterSetId: planExclusionFilterSetId,
      },
    });
  }
  /**
   * @param employerId
   * @returns PlanExclusionFilterSetDto
   * @throws ApiError
   */
  public employersControllerFindEmployerFilterSet(
    employerId: string
  ): CancelablePromise<PlanExclusionFilterSetDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/plan-exclusion-filter',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @param requestBody
   * @returns UpsertAllowanceModelResponseDto
   * @throws ApiError
   */
  public allowanceModelControllerUpsert(
    employerId: string,
    requestBody: UpsertAllowanceModelDto
  ): CancelablePromise<UpsertAllowanceModelResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employers/{employerId}/allowance-model',
      path: {
        employerId: employerId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @param year
   * @returns void
   * @throws ApiError
   */
  public allowanceModelControllerDelete(
    employerId: string,
    year: number
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/employers/{employerId}/allowance-model/year/{year}',
      path: {
        employerId: employerId,
        year: year,
      },
    });
  }
  /**
   * @param employerId
   * @param requestBody
   * @returns AllowanceModelDto
   * @throws ApiError
   */
  public allowanceModelControllerSearch(
    employerId: string,
    requestBody: GetAllowanceModelDto
  ): CancelablePromise<AllowanceModelDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employers/{employerId}/allowance-model/search',
      path: {
        employerId: employerId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @param year
   * @returns boolean
   * @throws ApiError
   */
  public allowanceModelControllerCheckAllowanceModelExists(
    employerId: string,
    year: number
  ): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/allowance-model/exists/year/{year}',
      path: {
        employerId: employerId,
        year: year,
      },
    });
  }
  /**
   * @param employerId
   * @returns boolean
   * @throws ApiError
   */
  public allowanceModelControllerHasRequiredAllowanceModels(
    employerId: string
  ): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employers/{employerId}/allowance-model/has-required-models',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @returns EmployeeClassesDto
   * @throws ApiError
   */
  public allowanceModelControllerGetEmployeeClasses(
    employerId: string
  ): CancelablePromise<EmployeeClassesDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/allowance-model/employee-classes',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @param year
   * @returns ClassDefinitionDto
   * @throws ApiError
   */
  public allowanceModelControllerGetClassDefinitionByYear(
    employerId: string,
    year: number
  ): CancelablePromise<ClassDefinitionDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/allowance-model/class-definitions/search/year/{year}',
      path: {
        employerId: employerId,
        year: year,
      },
    });
  }
  /**
   * @param employerId
   * @returns ClassDefinitionsForEmployerResultDto
   * @throws ApiError
   */
  public allowanceModelControllerGetAllClassDefinitionsForEmployer(
    employerId: string
  ): CancelablePromise<ClassDefinitionsForEmployerResultDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/allowance-model/class-definitions',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @param year
   * @returns string
   * @throws ApiError
   */
  public allowanceModelControllerGetCustomAttributesForEmployerByYear(
    employerId: string,
    year: number
  ): CancelablePromise<Array<string>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/allowance-model/custom-attributes/year/{year}',
      path: {
        employerId: employerId,
        year: year,
      },
    });
  }
  /**
   * @param employerId
   * @param requestBody
   * @returns FinchEmployerDto
   * @throws ApiError
   */
  public finchControllerUpdateEmployer(
    employerId: string,
    requestBody: UpdateFinchEmployerDto
  ): CancelablePromise<FinchEmployerDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/finch/{employerId}/employer',
      path: {
        employerId: employerId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @returns FinchEmployerDto
   * @throws ApiError
   */
  public finchControllerFindEmployer(
    employerId: string
  ): CancelablePromise<FinchEmployerDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/finch/{employerId}/employer',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @returns FinchPaymentDto
   * @throws ApiError
   */
  public finchControllerPayments(
    employerId: string
  ): CancelablePromise<Array<FinchPaymentDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/finch/{employerId}/payments',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @returns boolean
   * @throws ApiError
   */
  public finchControllerHasEmployeeIdentities(
    employerId: string
  ): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/finch/{employerId}/has-employee-identities',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @returns FinchEmployeeDto
   * @throws ApiError
   */
  public finchControllerFindEmployees(
    employerId: string
  ): CancelablePromise<Array<FinchEmployeeDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/finch/{employerId}/employee',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param providerId
   * @returns FinchProviderDto
   * @throws ApiError
   */
  public finchControllerGetFinchProvider(
    providerId: string
  ): CancelablePromise<FinchProviderDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/finch/provider/{providerId}',
      path: {
        providerId: providerId,
      },
    });
  }
  /**
   * @returns FinchProviderDto
   * @throws ApiError
   */
  public finchControllerGetAllProviders(): CancelablePromise<
    Array<FinchProviderDto>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/finch/providers',
    });
  }
  /**
   * @param requestBody
   * @returns FinchConnectResponseDto
   * @throws ApiError
   */
  public finchControllerConnect(
    requestBody: FinchConnectDto
  ): CancelablePromise<FinchConnectResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/finch/connect',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public finchControllerConnectCallback(
    requestBody: FinchConnectCallbackDto
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/finch/connect/callback',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public finchControllerIntrospect(
    requestBody: FinchConnectDto
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/finch/introspect',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public finchControllerDisconnect(
    requestBody: FinchConnectDto
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/finch/disconnect',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @returns void
   * @throws ApiError
   */
  public finchControllerSyncCompany(
    employerId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/finch/employers/{employerId}/sync',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @returns void
   * @throws ApiError
   */
  public finchControllerSyncEnrollments(
    employerId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/finch/employers/{employerId}/enrollments/sync',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @returns void
   * @throws ApiError
   */
  public finchControllerSyncProviders(): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/finch/providers/sync',
    });
  }
  /**
   * @param employerId
   * @returns EmploymentCandidatesSyncCountsDto
   * @throws ApiError
   */
  public finchControllerSyncEmploymentCandidates(
    employerId: string
  ): CancelablePromise<EmploymentCandidatesSyncCountsDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/finch/employers/{employerId}/employment-candidates/sync',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @returns FinchEmploymentExportDto
   * @throws ApiError
   */
  public finchControllerExportEmploymentData(
    employerId: string
  ): CancelablePromise<FinchEmploymentExportDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/finch/employers/{employerId}/employment-data/export',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @param idempotencyKey
   * @returns LinkedEmployeesSyncCountsDto
   * @throws ApiError
   */
  public finchControllerSyncLinkedEmployees(
    employerId: string,
    idempotencyKey: string
  ): CancelablePromise<LinkedEmployeesSyncCountsDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/finch/employers/{employerId}/linked-employees/sync',
      path: {
        employerId: employerId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
    });
  }
  /**
   * @param finchEmployerId
   * @param requestBody
   * @returns FinchEmployerEligibilityDto
   * @throws ApiError
   */
  public finchControllerUpsertEmployerEligibility(
    finchEmployerId: string,
    requestBody: UpsertFinchEmployerEligibilityDto
  ): CancelablePromise<FinchEmployerEligibilityDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/finch/{finchEmployerId}/eligibility',
      path: {
        finchEmployerId: finchEmployerId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param finchEmployerId
   * @returns FinchEmployerEligibilityDto
   * @throws ApiError
   */
  public finchControllerGetEmployerEligibility(
    finchEmployerId: string
  ): CancelablePromise<FinchEmployerEligibilityDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/finch/{finchEmployerId}/eligibility',
      path: {
        finchEmployerId: finchEmployerId,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns EmployerDocumentDto
   * @throws ApiError
   */
  public employerDocumentControllerPostDocument(
    id: string,
    requestBody: CreateEmployerDocumentDto
  ): CancelablePromise<EmployerDocumentDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employers/{id}/documents',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns EmployerDocumentDto
   * @throws ApiError
   */
  public employerDocumentControllerGetDocuments(
    id: string
  ): CancelablePromise<Array<EmployerDocumentDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{id}/documents',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param documentId
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public employerDocumentControllerUpdateDocument(
    documentId: string,
    requestBody: UpdateEmployerDocumentDto
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employers/{id}/documents/{documentId}',
      path: {
        documentId: documentId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param documentId
   * @returns void
   * @throws ApiError
   */
  public employerDocumentControllerDeleteDocument(
    id: string,
    documentId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/employers/{id}/documents/{documentId}',
      path: {
        id: id,
        documentId: documentId,
      },
    });
  }
  /**
   * @param id
   * @param documentId
   * @returns EmployerDocumentDto
   * @throws ApiError
   */
  public employerDocumentControllerGetDocument(
    id: string,
    documentId: string
  ): CancelablePromise<EmployerDocumentDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{id}/documents/{documentId}',
      path: {
        id: id,
        documentId: documentId,
      },
    });
  }
  /**
   * @param id
   * @param documentUrl
   * @returns EmployerDocumentDto
   * @throws ApiError
   */
  public employerDocumentControllerGetDocumentByUrl(
    id: string,
    documentUrl: string
  ): CancelablePromise<EmployerDocumentDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{id}/documents/by-url',
      path: {
        id: id,
      },
      query: {
        documentUrl: documentUrl,
      },
    });
  }
  /**
   * @param id
   * @param type
   * @returns EmployerDocumentDto
   * @throws ApiError
   */
  public employerDocumentControllerGetDocumentsByType(
    id: string,
    type: 'PLAN' | 'ZORRO_PAY' | 'ADMIN' | 'COMPLIANCE' | 'INVOICE'
  ): CancelablePromise<Array<EmployerDocumentDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{id}/documents/by-type/{type}',
      path: {
        id: id,
        type: type,
      },
    });
  }
  /**
   * @param employerId
   * @returns EnrollmentInstructionsDto
   * @throws ApiError
   */
  public enrollmentInstructionsControllerFind(
    employerId: string
  ): CancelablePromise<EnrollmentInstructionsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/enrollment-instructions',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @param requestBody
   * @returns EnrollmentInstructionsDto
   * @throws ApiError
   */
  public enrollmentInstructionsControllerUpsert(
    employerId: string,
    requestBody: UpsertEnrollmentInstructionsDto
  ): CancelablePromise<EnrollmentInstructionsDto> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employers/{employerId}/enrollment-instructions',
      path: {
        employerId: employerId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public eventsControllerCollect(
    requestBody: EventDto
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/events',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param idempotencyKey
   * @param requestBody
   * @returns OpenEnrollmentPeriodDto
   * @throws ApiError
   */
  public openEnrollmentPeriodsControllerCreate(
    idempotencyKey: string,
    requestBody: CreateOpenEnrollmentPeriodDto
  ): CancelablePromise<OpenEnrollmentPeriodDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/open-enrollment-periods',
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns OpenEnrollmentPeriodDto
   * @throws ApiError
   */
  public openEnrollmentPeriodsControllerFindAll(): CancelablePromise<
    Array<OpenEnrollmentPeriodDto>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/open-enrollment-periods',
    });
  }
  /**
   * @param employerId
   * @returns OpenEnrollmentPeriodDto
   * @throws ApiError
   */
  public openEnrollmentPeriodsControllerFindAllForEmployer(
    employerId: string
  ): CancelablePromise<Array<OpenEnrollmentPeriodDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/open-enrollment-periods',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param id
   * @returns OpenEnrollmentPeriodDto
   * @throws ApiError
   */
  public openEnrollmentPeriodsControllerFind(
    id: string
  ): CancelablePromise<OpenEnrollmentPeriodDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/open-enrollment-periods/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param idempotencyKey
   * @param requestBody
   * @returns OpenEnrollmentPeriodUpdateErrorDto
   * @throws ApiError
   */
  public openEnrollmentPeriodsControllerUpdate(
    id: string,
    idempotencyKey: string,
    requestBody: UpdateOpenEnrollmentPeriodDto
  ): CancelablePromise<Array<OpenEnrollmentPeriodUpdateErrorDto>> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/open-enrollment-periods/{id}',
      path: {
        id: id,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param mode
   * @param findByDate
   * @returns OpenEnrollmentPeriodDto
   * @throws ApiError
   */
  public openEnrollmentPeriodsControllerFindEmployerRelevantOpenEnrollmentPeriod(
    id: string,
    mode: OpenEnrollmentPeriodsRelevancyMode,
    findByDate?: string
  ): CancelablePromise<OpenEnrollmentPeriodDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{id}/open-enrollment-periods/relevant',
      path: {
        id: id,
      },
      query: {
        mode: mode,
        findByDate: findByDate,
      },
    });
  }
  /**
   * @param employerId
   * @returns SubEntityDto
   * @throws ApiError
   */
  public subEntityControllerFindMany(
    employerId: string
  ): CancelablePromise<Array<SubEntityDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/sub-entity/{employerId}',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public subEntityControllerUpsertMany(
    employerId: string,
    requestBody: Array<string>
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/sub-entity/{employerId}',
      path: {
        employerId: employerId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @param name
   * @returns SubEntityDto
   * @throws ApiError
   */
  public subEntityControllerFindOne(
    employerId: string,
    name: string
  ): CancelablePromise<SubEntityDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/sub-entity/{employerId}/{name}',
      path: {
        employerId: employerId,
        name: name,
      },
    });
  }
  /**
   * @param employerId
   * @returns SubEntityDto
   * @throws ApiError
   */
  public subEntity2ControllerFindMany(
    employerId: string
  ): CancelablePromise<Array<SubEntityDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/sub-entity-2/{employerId}',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public subEntity2ControllerUpsertMany(
    employerId: string,
    requestBody: Array<string>
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/sub-entity-2/{employerId}',
      path: {
        employerId: employerId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @param name
   * @returns SubEntityDto
   * @throws ApiError
   */
  public subEntity2ControllerFindOne(
    employerId: string,
    name: string
  ): CancelablePromise<SubEntityDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/sub-entity-2/{employerId}/{name}',
      path: {
        employerId: employerId,
        name: name,
      },
    });
  }
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public supportControllerReportIssue(
    requestBody: ReportSupportIssuePayloadDto
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/support/report-issue',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns any The Health Check is successful
   * @throws ApiError
   */
  public healthControllerLiveness(): CancelablePromise<{
    status?: string;
    info?: Record<string, Record<string, any>> | null;
    error?: Record<string, Record<string, any>> | null;
    details?: Record<string, Record<string, any>>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/health/liveness',
      errors: {
        503: `The Health Check is not successful`,
      },
    });
  }
  /**
   * @returns any The Health Check is successful
   * @throws ApiError
   */
  public healthControllerReadiness(): CancelablePromise<{
    status?: string;
    info?: Record<string, Record<string, any>> | null;
    error?: Record<string, Record<string, any>> | null;
    details?: Record<string, Record<string, any>>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/health/readiness',
      errors: {
        503: `The Health Check is not successful`,
      },
    });
  }
  /**
   * @param zipCode The zip code of the location to center the search on
   * @param radius The search radius in miles (max 200). Defaults to 20 miles if not provided.
   * @param specialtyIds The specialty category IDs to search for
   * @param searchTerm The search term to use when searching for providers
   * @param type The entity type of the provider
   * @returns MajorMedicalProvider
   * @throws ApiError
   */
  public planCatalogControllerSearchMajorMedicalProviders(
    zipCode: string,
    radius?: number,
    specialtyIds?: Array<string>,
    searchTerm?: string,
    type?: string
  ): CancelablePromise<Array<MajorMedicalProvider>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/plan-catalog/major-medical/providers',
      query: {
        radius: radius,
        specialtyIds: specialtyIds,
        searchTerm: searchTerm,
        type: type,
        zipCode: zipCode,
      },
    });
  }
  /**
   * @param ids The NPIs to search for
   * @returns MajorMedicalProvider
   * @throws ApiError
   */
  public planCatalogControllerSearchMajorMedicalProvidersByIds(
    ids: Array<number>
  ): CancelablePromise<Array<MajorMedicalProvider>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/plan-catalog/major-medical/providers-by-ids',
      query: {
        ids: ids,
      },
    });
  }
  /**
   * @param ids The NPIs to search for
   * @param employeeId
   * @returns MajorMedicalProvider
   * @throws ApiError
   */
  public planCatalogControllerSearchEmployeeMajorMedicalProvidersByIdsAndZipCode(
    ids: Array<number>,
    employeeId: string
  ): CancelablePromise<Array<MajorMedicalProvider>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/plan-catalog/major-medical/{employeeId}/providers-by-ids',
      path: {
        employeeId: employeeId,
      },
      query: {
        ids: ids,
      },
    });
  }
  /**
   * @param searchTerm The search term to use when searching for drugs
   * @returns MajorMedicalDrug
   * @throws ApiError
   */
  public planCatalogControllerSearchMajorMedicalDrugs(
    searchTerm: string
  ): CancelablePromise<Array<MajorMedicalDrug>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/plan-catalog/major-medical/drugs',
      query: {
        searchTerm: searchTerm,
      },
    });
  }
  /**
   * @param requestBody
   * @returns MedicalPlan
   * @throws ApiError
   */
  public planCatalogControllerSearchMajorMedicalPlans(
    requestBody: MedicalPlanSearchRequest
  ): CancelablePromise<Array<MedicalPlan>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/plan-catalog/major-medical/plans',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns MedicalPlan
   * @throws ApiError
   */
  public planCatalogControllerPublicSearchMajorMedicalPlans(
    requestBody: PublicMedicalPlanSearchRequest
  ): CancelablePromise<Array<MedicalPlan>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/plan-catalog/major-medical/public-plans',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns MajorMedicalSpecialtyCategory
   * @throws ApiError
   */
  public planCatalogControllerGetMajorMedicalSpecialtiesCategories(): CancelablePromise<
    Array<MajorMedicalSpecialtyCategory>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/plan-catalog/major-medical/specialties-categories',
    });
  }
  /**
   * @param effectiveDate The effective date to get the carriers, plans, and benefits for
   * @returns CarriersPlansBenefitsCarrierDto
   * @throws ApiError
   */
  public planCatalogControllerGetCarriersPlansBenefits(
    effectiveDate: string
  ): CancelablePromise<Array<CarriersPlansBenefitsCarrierDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/plan-catalog/supplementals/carriers-plans-benefits',
      query: {
        effectiveDate: effectiveDate,
      },
    });
  }
  /**
   * @param requestBody
   * @returns SupplementalPlanDto
   * @throws ApiError
   */
  public planCatalogControllerSearchDentalPlans(
    requestBody: SupplementalQuoteRequest
  ): CancelablePromise<Array<SupplementalPlanDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/plan-catalog/supplementals/dental-plans',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns SupplementalPlanDto
   * @throws ApiError
   */
  public planCatalogControllerSearchVisionPlans(
    requestBody: SupplementalQuoteRequest
  ): CancelablePromise<Array<SupplementalPlanDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/plan-catalog/supplementals/vision-plans',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param planYear
   * @param requestBody
   * @returns CmsQualityRatingsUploadSummaryDto
   * @throws ApiError
   */
  public qualityRatingsControllerReplacePlanYearRatings(
    planYear: number,
    requestBody: CmsQualityRatingsUploadDto
  ): CancelablePromise<CmsQualityRatingsUploadSummaryDto> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/quality-ratings/{planYear}',
      path: {
        planYear: planYear,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @param year
   * @returns AllowanceModelSourceMetadataDto
   * @throws ApiError
   */
  public allowanceModelSourceControllerFindSourceMetadata(
    employerId: string,
    year: number
  ): CancelablePromise<AllowanceModelSourceMetadataDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/allowance-model-source/year/{year}/metadata',
      path: {
        employerId: employerId,
        year: year,
      },
    });
  }
  /**
   * @param employerId
   * @param year
   * @param requestBody
   * @returns AllowanceModelSourceMetadataDto
   * @throws ApiError
   */
  public allowanceModelSourceControllerUpsertManualSource(
    employerId: string,
    year: number,
    requestBody: UpsertManualAllowanceModelSourceDto
  ): CancelablePromise<AllowanceModelSourceMetadataDto> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/employers/{employerId}/allowance-model-source/year/{year}',
      path: {
        employerId: employerId,
        year: year,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @param year
   * @returns void
   * @throws ApiError
   */
  public allowanceModelSourceControllerDeleteSource(
    employerId: string,
    year: number
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/employers/{employerId}/allowance-model-source/year/{year}',
      path: {
        employerId: employerId,
        year: year,
      },
    });
  }
  /**
   * @param requestBody
   * @returns QuotePlanDesignDto
   * @throws ApiError
   */
  public quotePlanDesignControllerCreate(
    requestBody: CreateQuotePlanDesignDto
  ): CancelablePromise<QuotePlanDesignDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/quote-plan-design',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param quoteId
   * @returns QuotePlanDesignDto
   * @throws ApiError
   */
  public quotePlanDesignControllerFindAllForQuote(
    quoteId: string
  ): CancelablePromise<Array<QuotePlanDesignDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quote-plan-design',
      query: {
        quoteId: quoteId,
      },
    });
  }
  /**
   * @param employerId
   * @param excludeQuoteId
   * @returns CarryOverSourceQuoteDto
   * @throws ApiError
   */
  public quotePlanDesignControllerFindCarryOverSources(
    employerId: string,
    excludeQuoteId?: string
  ): CancelablePromise<Array<CarryOverSourceQuoteDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quote-plan-design/carry-over-sources',
      query: {
        employerId: employerId,
        excludeQuoteId: excludeQuoteId,
      },
    });
  }
  /**
   * @param planId
   * @returns QuotePlanDesignDto
   * @throws ApiError
   */
  public quotePlanDesignControllerFindOne(
    planId: string
  ): CancelablePromise<QuotePlanDesignDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quote-plan-design/{planId}',
      path: {
        planId: planId,
      },
    });
  }
  /**
   * @param planId
   * @param requestBody
   * @returns QuotePlanDesignDto
   * @throws ApiError
   */
  public quotePlanDesignControllerUpdate(
    planId: string,
    requestBody: UpdateQuotePlanDesignDto
  ): CancelablePromise<QuotePlanDesignDto> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/quote-plan-design/{planId}',
      path: {
        planId: planId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param planId
   * @returns void
   * @throws ApiError
   */
  public quotePlanDesignControllerRemove(
    planId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/quote-plan-design/{planId}',
      path: {
        planId: planId,
      },
    });
  }
  /**
   * @param requestBody
   * @returns GetQuoteDto
   * @throws ApiError
   */
  public quotesControllerCreate(
    requestBody: CreateQuoteDto
  ): CancelablePromise<GetQuoteDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/quotes',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @returns GetQuoteDto
   * @throws ApiError
   */
  public quotesControllerFindAll(
    employerId: string
  ): CancelablePromise<Array<GetQuoteDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes',
      query: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns GetQuoteDto
   * @throws ApiError
   */
  public quotesControllerUpdate(
    id: string,
    requestBody: UpdateQuoteDto
  ): CancelablePromise<GetQuoteDto> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/quotes/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns GetQuoteDto
   * @throws ApiError
   */
  public quotesControllerFindOne(id: string): CancelablePromise<GetQuoteDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns void
   * @throws ApiError
   */
  public quotesControllerRemove(id: string): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/quotes/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns StartQuoteGenerationResultDto
   * @throws ApiError
   */
  public quotesControllerGenerateOutput(
    id: string,
    requestBody?: GenerateQuoteOutputRequestDto
  ): CancelablePromise<StartQuoteGenerationResultDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/quotes/{id}/generateOutput',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns GetCensusPlanDto
   * @throws ApiError
   */
  public quotesControllerFindCensusPlans(
    id: string
  ): CancelablePromise<Array<GetCensusPlanDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/census-plans',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns CensusEmployeeDto
   * @throws ApiError
   */
  public quotesControllerFindCensusEmployees(
    id: string
  ): CancelablePromise<Array<CensusEmployeeDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/census-employees',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns AllQuoteScenariosDto
   * @throws ApiError
   */
  public quotesControllerGetAllQuoteScenarios(
    id: string
  ): CancelablePromise<AllQuoteScenariosDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/all-scenarios',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param zipQuery
   * @returns GetZipCodeDto
   * @throws ApiError
   */
  public quotesControllerSearchZipCodes(
    zipQuery: string
  ): CancelablePromise<Array<GetZipCodeDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/quotes/zip-codes',
      query: {
        zipQuery: zipQuery,
      },
    });
  }
  /**
   * @param id
   * @param planDesignId
   * @param employeeId
   * @returns GetZipCodeDto
   * @throws ApiError
   */
  public quotesControllerGetEmployeePricingCounty(
    id: string,
    planDesignId: string,
    employeeId: string
  ): CancelablePromise<GetZipCodeDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/plan-designs/{planDesignId}/employees/{employeeId}/pricing-county',
      path: {
        id: id,
        planDesignId: planDesignId,
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns CensusEmployeeDto
   * @throws ApiError
   */
  public quotesControllerSearchCensusEmployees(
    id: string,
    requestBody: SearchCensusEmployeesRequestDto
  ): CancelablePromise<Array<CensusEmployeeDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/quotes/{id}/census-employees/search',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param planDesignId
   * @param scenario
   * @param familyUnitDistribution
   * @param employeeIdFromEmployer
   * @returns number
   * @throws ApiError
   */
  public quotesControllerGetEmployeeAllowance(
    id: string,
    planDesignId: string,
    scenario: string,
    familyUnitDistribution: string,
    employeeIdFromEmployer: string
  ): CancelablePromise<number> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/employee-allowance/{planDesignId}/scenario/{scenario}/family-unit-distribution/{familyUnitDistribution}/employee/{employeeIdFromEmployer}',
      path: {
        id: id,
        planDesignId: planDesignId,
        scenario: scenario,
        familyUnitDistribution: familyUnitDistribution,
        employeeIdFromEmployer: employeeIdFromEmployer,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns AllowanceModelCalculationResponseDto
   * @throws ApiError
   */
  public quotesControllerCalculateAllowanceModel(
    id: string,
    requestBody: AllowanceModelCalculationRequestDto
  ): CancelablePromise<AllowanceModelCalculationResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/quotes/{id}/allowance-model',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param planDesignId
   * @returns QuoteAllowanceModelRow
   * @throws ApiError
   */
  public quotesControllerGetAllowanceModel(
    id: string,
    planDesignId: string
  ): CancelablePromise<Array<QuoteAllowanceModelRow>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/allowance-model/{planDesignId}',
      path: {
        id: id,
        planDesignId: planDesignId,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public quotesControllerApplyAllowanceModel(
    id: string,
    requestBody: ApplyAllowanceModelRequestDto
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/quotes/{id}/allowance-model/apply',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns GeoClassesCountResult
   * @throws ApiError
   */
  public quotesControllerCountClassesByGeoDistribution(
    id: string
  ): CancelablePromise<Array<GeoClassesCountResult>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/geo-distribution-classes',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param planDesignId
   * @returns AvgPremiumsResult
   * @throws ApiError
   */
  public quotesControllerGetAvgPremiumsForSelectedScenario(
    id: string,
    planDesignId: string
  ): CancelablePromise<Array<AvgPremiumsResult>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/average-premiums',
      path: {
        id: id,
      },
      query: {
        planDesignId: planDesignId,
      },
    });
  }
  /**
   * @param id
   * @param planDesignId
   * @returns PresetWithContributionAndGeoDistribution
   * @throws ApiError
   */
  public quotesControllerGetPresetsWithAllowanceContribution(
    id: string,
    planDesignId: string
  ): CancelablePromise<Array<PresetWithContributionAndGeoDistribution>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/contribution-presets',
      path: {
        id: id,
      },
      query: {
        planDesignId: planDesignId,
      },
    });
  }
  /**
   * @param id
   * @param scenario
   * @returns boolean
   * @throws ApiError
   */
  public quotesControllerGetIsSavingSplitAvailable(
    id: string,
    scenario: string
  ): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/scenario/{scenario}/saving-split-available',
      path: {
        id: id,
        scenario: scenario,
      },
    });
  }
  /**
   * @param id
   * @param planDesignId
   * @param scenario
   * @param familyUnitDistribution
   * @returns EmployeeBreakdownDto
   * @throws ApiError
   */
  public quotesControllerGetEmployeesBreakdown(
    id: string,
    planDesignId: string,
    scenario: string,
    familyUnitDistribution: string
  ): CancelablePromise<Array<EmployeeBreakdownDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/employee-breakdown/{planDesignId}/scenario/{scenario}/family-unit-distribution/{familyUnitDistribution}',
      path: {
        id: id,
        planDesignId: planDesignId,
        scenario: scenario,
        familyUnitDistribution: familyUnitDistribution,
      },
    });
  }
  /**
   * @param id
   * @returns StateDistributionResultDto
   * @throws ApiError
   */
  public quotesControllerGetStateDistribution(
    id: string
  ): CancelablePromise<Array<StateDistributionResultDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/state-distribution-count',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns RenewalRateChangeDto
   * @throws ApiError
   */
  public quotesControllerGetRenewalRateChanges(
    id: string
  ): CancelablePromise<Array<RenewalRateChangeDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quotes/{id}/renewal-rate-changes',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param requestBody
   * @returns QuoteSessionDto
   * @throws ApiError
   */
  public quoteSessionControllerUpsert(
    requestBody: QuoteSessionDto
  ): CancelablePromise<QuoteSessionDto> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/quote-session',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns QuoteSessionDto
   * @throws ApiError
   */
  public quoteSessionControllerFindOne(
    id: string
  ): CancelablePromise<QuoteSessionDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/quote-session/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param requestBody
   * @returns SolutionsResponseDto
   * @throws ApiError
   */
  public aiCockpitControllerGetSolutions(
    requestBody: GetSolutionsDto
  ): CancelablePromise<SolutionsResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ai-cockpit/solutions',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public recommendationDataControllerUpdateRecommendationData(
    requestBody: RecommendationDataInputDto
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/recommendation-data',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns RecommendationDataDto
   * @throws ApiError
   */
  public recommendationDataControllerSearchRecommendationData(
    requestBody: RecommendationDataSearchDto
  ): CancelablePromise<Array<RecommendationDataDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/recommendation-data/search',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns ScheduleMonthlyBillingWorkflowsResponseDto
   * @throws ApiError
   */
  public monthlyBillingControllerScheduleMonthlyBillingWorkflows(
    requestBody: ScheduleMonthlyBillingWorkflowsRequestDto
  ): CancelablePromise<ScheduleMonthlyBillingWorkflowsResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/monthly-billing/schedule-workflows',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns AgencyReportRowDto
   * @throws ApiError
   */
  public agencyReportsControllerGenerateAgenciesReport(): CancelablePromise<
    Array<AgencyReportRowDto>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/agencyReports',
    });
  }
  /**
   * @param id
   * @returns AgentReportRowDto
   * @throws ApiError
   */
  public agencyReportsControllerGenerateAgentsReport(
    id: string
  ): CancelablePromise<Array<AgentReportRowDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/agencies/{id}/report',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param employerId
   * @param openEnrollmentPeriodId
   * @param requestBody
   * @returns PaginatedEmployeesReportRowDto
   * @throws ApiError
   */
  public employeeReportsControllerGenerateEmployeesReport(
    employerId: string,
    openEnrollmentPeriodId: string,
    requestBody: GenerateEmployeesReportDto
  ): CancelablePromise<PaginatedEmployeesReportRowDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employee-reports/employers/{employerId}/open-enrollment-period/{openEnrollmentPeriodId}',
      path: {
        employerId: employerId,
        openEnrollmentPeriodId: openEnrollmentPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param isDemo
   * @returns EmployerReportRowDto
   * @throws ApiError
   */
  public employerReportsControllerGenerateEmployerReport(
    isDemo: boolean
  ): CancelablePromise<Array<EmployerReportRowDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employersReport',
      query: {
        isDemo: isDemo,
      },
    });
  }
  /**
   * @param employerId
   * @returns CompanyOverviewDto
   * @throws ApiError
   */
  public employerReportsControllerGenerateCompanyOverviewReport(
    employerId: string
  ): CancelablePromise<CompanyOverviewDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{employerId}/overview',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param requestBody
   * @returns EnrollmentSummaryResponseDto
   * @throws ApiError
   */
  public enrollmentReportsControllerGenerateEnrollmentSummary(
    requestBody: EnrollmentSummaryRequestDto
  ): CancelablePromise<EnrollmentSummaryResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/enrollment-reports/enrollment-summaries',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns SingleOnboardingPeriodStatusesDto
   * @throws ApiError
   */
  public enrollmentReportsControllerFetchOnboardingPeriodStatuses(
    requestBody: FetchOnboardingPeriodStatusesRequestDto
  ): CancelablePromise<Array<SingleOnboardingPeriodStatusesDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/enrollment-reports/onboarding-period-statuses',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param enrollmentTeamId
   * @param requestBody
   * @returns PaginatedEnrollmentReportRowDto
   * @throws ApiError
   */
  public enrollmentReportsControllerGenerateEnrollmentsReport(
    enrollmentTeamId: string,
    requestBody: GenerateEnrollmentsReportDto
  ): CancelablePromise<PaginatedEnrollmentReportRowDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/enrollment-reports/{enrollmentTeamId}',
      path: {
        enrollmentTeamId: enrollmentTeamId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param periodId
   * @returns SingleOnboardingPeriodStatusesDto
   * @throws ApiError
   */
  public enrollmentReportsControllerFetchSingleOnboardingPeriodStatuses(
    periodId: string
  ): CancelablePromise<SingleOnboardingPeriodStatusesDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/enrollment-reports/{periodId}/onboarding-period-statuses',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param periodId
   * @returns OnboardingPeriodReportDto
   * @throws ApiError
   */
  public onboardingPeriodReportsControllerGenerateOnboardingPeriodReport(
    periodId: string
  ): CancelablePromise<OnboardingPeriodReportDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/onboarding-periods/{periodId}/onboarding-period-report',
      path: {
        periodId: periodId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns OnboardingPeriodReportDto
   * @throws ApiError
   */
  public onboardingPeriodReportsControllerGenerateEmployeeOnboardingReport(
    employeeId: string
  ): CancelablePromise<Array<OnboardingPeriodReportDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods-report',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param id
   * @param perPage Number of onboarding periods per page
   * @param page The page number to retrieve
   * @returns PaginatedEmployerOnboardingReportDto
   * @throws ApiError
   */
  public onboardingPeriodReportsControllerGenerateEmployerOnboardingReport(
    id: string,
    perPage?: number,
    page?: number
  ): CancelablePromise<PaginatedEmployerOnboardingReportDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employers/{id}/onboarding-periods',
      path: {
        id: id,
      },
      query: {
        perPage: perPage,
        page: page,
      },
    });
  }
  /**
   * @param employerId
   * @param requestBody
   * @returns PaginatedPayrollReportRowDto
   * @throws ApiError
   */
  public payrollReportControllerGeneratePayrollReport(
    employerId: string,
    requestBody: GeneratePayrollReportDto
  ): CancelablePromise<PaginatedPayrollReportRowDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employers/{employerId}/payroll',
      path: {
        employerId: employerId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns PaginatedProspectsReportRowDto
   * @throws ApiError
   */
  public prospectReportControllerGenerateProspectReport(
    requestBody: GenerateProspectsReportDto
  ): CancelablePromise<PaginatedProspectsReportRowDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/prospect-report',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employerId
   * @returns any
   * @throws ApiError
   */
  public customerDataTasksControllerSyncIntercomEmployer(
    employerId: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/customer-data-tasks/{employerId}/intercom-sync-employer',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param agencyId
   * @returns any
   * @throws ApiError
   */
  public customerDataTasksControllerSyncIntercomAgency(
    agencyId: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/customer-data-tasks/{agencyId}/intercom-sync-agency',
      path: {
        agencyId: agencyId,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public customerDataTasksControllerTriggerBenefitStatusUpdates(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/customer-data-tasks/benefit-status-updates',
    });
  }
  /**
   * @param requestBody
   * @returns IntercomUserHashResponseDto
   * @throws ApiError
   */
  public intercomControllerGenerateHash(
    requestBody: IntercomUserHashPayloadDto
  ): CancelablePromise<IntercomUserHashResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/intercom/users/generate-hash',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns IntercomSyncStatus
   * @throws ApiError
   */
  public intercomControllerGetAllSyncStatuses(): CancelablePromise<
    Array<IntercomSyncStatus>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/intercom/get-all-sync-statuses',
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public intercomControllerDeleteSyncStatus(
    id: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/intercom/delete-sync-status/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param requestBody
   * @returns GenerateActivationLinkResponseDto
   * @throws ApiError
   */
  public userActivationLinksControllerGenerateActivationLink(
    requestBody: CreateActivationLinkDto
  ): CancelablePromise<GenerateActivationLinkResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/user-activation-links',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns string
   * @throws ApiError
   */
  public userActivationLinksControllerGenerateFronteggActivationToken(
    id: string
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/user-activation-links/{id}/generateFronteggActivationToken',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param requestBody
   * @returns ActivationLinkDto
   * @throws ApiError
   */
  public userActivationLinksControllerGetByUserIds(
    requestBody: GetByUserIdsDto
  ): CancelablePromise<Array<ActivationLinkDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/user-activation-links/getByUserIds',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param userIds
   * @param employerId
   * @returns any
   * @throws ApiError
   */
  public userActivationLinksControllerDisableInvitation(
    userIds: Array<string>,
    employerId: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/user-activation-links/disable-invitation',
      query: {
        userIds: userIds,
        employerId: employerId,
      },
    });
  }
  /**
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public usersControllerSyncEmployeeName(
    requestBody: SyncEmployeeNameDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/users/syncEmployeeName',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public usersControllerSyncEmployerName(
    requestBody: SyncEmployerNameDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/users/syncEmployerName',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public usersControllerSyncAgencyName(
    requestBody: SyncAgencyNameDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/users/syncAgencyName',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param roles
   * @param requestBody
   * @returns string
   * @throws ApiError
   */
  public usersControllerUpsert(
    roles: Array<string>,
    requestBody: CreateUserDto
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/users',
      query: {
        roles: roles,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param tenantId
   * @param roles
   * @param requestBody
   * @returns UpsertManyUsersResponseDto
   * @throws ApiError
   */
  public usersControllerUpsertMany(
    tenantId: string,
    roles: Array<string>,
    requestBody: Array<CreateManyUsersDto>
  ): CancelablePromise<UpsertManyUsersResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/users',
      query: {
        tenantId: tenantId,
        roles: roles,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param ids
   * @returns UserDto
   * @throws ApiError
   */
  public usersControllerGetUsersFromFronteggByIds(
    ids: Array<string>
  ): CancelablePromise<Array<UserDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users',
      query: {
        ids: ids,
      },
    });
  }
  /**
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public usersControllerSendActivationEmails(
    requestBody: Array<UserAndTenantDto>
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/users/send-activation-emails',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public usersControllerGetAllUsersRoles(
    requestBody: UsersRolesDto
  ): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users/all/roles',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param userId
   * @returns GetUserRolesDto
   * @throws ApiError
   */
  public usersControllerGetUserRoles(
    userId: string
  ): CancelablePromise<GetUserRolesDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users/{userId}/roles',
      path: {
        userId: userId,
      },
    });
  }
  /**
   * @param requestBody
   * @returns ChangeCustomerFacingRolesResultDto
   * @throws ApiError
   */
  public usersControllerChangeCustomerFacingRole(
    requestBody: ChangeCustomerFacingRolesDto
  ): CancelablePromise<ChangeCustomerFacingRolesResultDto> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/users/roles',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param userId
   * @returns PasswordResetDto
   * @throws ApiError
   */
  public usersControllerGeneratePasswordResetToken(
    userId: string
  ): CancelablePromise<PasswordResetDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/users/{userId}/password-reset-token',
      path: {
        userId: userId,
      },
    });
  }
  /**
   * @param email
   * @returns UserDto
   * @throws ApiError
   */
  public usersControllerFindUserByEmail(
    email: string
  ): CancelablePromise<UserDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users/find-by-email/{email}',
      path: {
        email: email,
      },
    });
  }
  /**
   * @param requestBody
   * @returns UserDto
   * @throws ApiError
   */
  public usersControllerFindUsersByEmails(
    requestBody: UserEmailsDto
  ): CancelablePromise<Array<UserDto>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/users/find-by-emails',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns UserDto
   * @throws ApiError
   */
  public usersControllerGetAll(): CancelablePromise<Array<UserDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users/all',
    });
  }
  /**
   * @returns UserDto
   * @throws ApiError
   */
  public usersControllerGetOmnipotentAdmins(): CancelablePromise<
    Array<UserDto>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users/omnipotent-admins',
    });
  }
  /**
   * @param tenantId
   * @returns UserDto
   * @throws ApiError
   */
  public usersControllerGetEmployerAdmins(
    tenantId: string
  ): CancelablePromise<Array<UserDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users/employer-admins/{tenantId}',
      path: {
        tenantId: tenantId,
      },
    });
  }
  /**
   * @param tenantId
   * @returns UserDto
   * @throws ApiError
   */
  public usersControllerGetAllUsersFromTenant(
    tenantId: string
  ): CancelablePromise<Array<UserDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users/all/{tenantId}',
      query: {
        tenantId: tenantId,
      },
    });
  }
  /**
   * @param requestBody
   * @returns UserStatusDto
   * @throws ApiError
   */
  public usersControllerGetUsersTenantsStatuses(
    requestBody: UserIdsDto
  ): CancelablePromise<Array<UserStatusDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users/statuses',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param userId
   * @param tenantId
   * @returns void
   * @throws ApiError
   */
  public usersControllerDeleteUser(
    userId: string,
    tenantId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/users/{userId}',
      path: {
        userId: userId,
      },
      query: {
        tenantId: tenantId,
      },
    });
  }
  /**
   * @param userId
   * @returns UserDto
   * @throws ApiError
   */
  public usersControllerFindUser(userId: string): CancelablePromise<UserDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users/{userId}',
      path: {
        userId: userId,
      },
    });
  }
  /**
   * @param tenantId
   * @returns any
   * @throws ApiError
   */
  public usersControllerDeleteUsers(tenantId: string): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/users/all-company-users/{tenantId}',
      path: {
        tenantId: tenantId,
      },
    });
  }
  /**
   * @param userId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public usersControllerUpdateCompanyEmail(
    userId: string,
    requestBody: EmailDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/users/{userId}/update-company-email',
      path: {
        userId: userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param userId
   * @param tenantId
   * @returns UserDtoWithRoles
   * @throws ApiError
   */
  public usersControllerGetFronteggUser(
    userId: string,
    tenantId: string
  ): CancelablePromise<UserDtoWithRoles> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/users/frontegg/{userId}',
      path: {
        userId: userId,
      },
      query: {
        tenantId: tenantId,
      },
    });
  }
  /**
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public usersControllerUpdateUserStatus(
    requestBody: UserStatusDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/users/{userId}/status',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public carrierInfoControllerUpsert(
    requestBody: Array<CarrierInfoWithoutIdDto>
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/carriers',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param name
   * @param state
   * @returns CarrierInfoDto
   * @throws ApiError
   */
  public carrierInfoControllerFindOneByNameAndState(
    name: string,
    state: USState
  ): CancelablePromise<CarrierInfoDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/carriers/by-name-and-state',
      query: {
        name: name,
        state: state,
      },
    });
  }
  /**
   * @param state
   * @returns CarrierInfoDto
   * @throws ApiError
   */
  public carrierInfoControllerFindManyByState(
    state: USState
  ): CancelablePromise<Array<CarrierInfoDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/carriers/by-state',
      query: {
        state: state,
      },
    });
  }
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public stateAppointmentControllerUpsert(
    requestBody: Array<StateAppointmentWithoutIdDto>
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/state-appointments',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param code
   * @returns StateAppointmentDto
   * @throws ApiError
   */
  public stateAppointmentControllerFindByCode(
    code: USState
  ): CancelablePromise<StateAppointmentDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/state-appointments/{code}',
      path: {
        code: code,
      },
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns EmployeePaymentMethodDetailsDto
   * @throws ApiError
   */
  public paymentsControllerEmployeePaymentMethodDetails(
    employeeId: string,
    requestBody: EmployeePaymentMethodDetailsPayloadDto
  ): CancelablePromise<EmployeePaymentMethodDetailsDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments-v1/v3/{employeeId}/details',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param idempotencyKey
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public paymentsControllerUpdatePaymentMethodAssociatedBenefits(
    employeeId: string,
    idempotencyKey: string,
    requestBody: UpdateEmployeePaymentMethodAssociatedBenefitsPayloadDto
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments-v1/{employeeId}/update-associated-benefits',
      path: {
        employeeId: employeeId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns EmployeePaymentMethodDto
   * @throws ApiError
   */
  public paymentsControllerCreatePaymentMethod(
    employeeId: string,
    requestBody: CreateEmployeePaymentMethodPayloadDto
  ): CancelablePromise<EmployeePaymentMethodDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments-v1/{employeeId}/create',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param requestBody
   * @returns EmployeePaymentMethodDto
   * @throws ApiError
   */
  public paymentsControllerUpdatePaymentMethod(
    employeeId: string,
    requestBody: UpdateEmployeePaymentMethodPayloadDto
  ): CancelablePromise<EmployeePaymentMethodDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments-v1/{employeeId}/update',
      path: {
        employeeId: employeeId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param onboardingPeriodId
   * @returns EmployeePaymentMethodDto
   * @throws ApiError
   */
  public paymentsControllerGetPaymentMethod(
    employeeId: string,
    onboardingPeriodId: string
  ): CancelablePromise<EmployeePaymentMethodDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payments-v1/{employeeId}',
      path: {
        employeeId: employeeId,
      },
      query: {
        onboardingPeriodId: onboardingPeriodId,
      },
    });
  }
  /**
   * @returns TriggerDueRequestsResponseDto
   * @throws ApiError
   */
  public paymentRequestControllerTriggerDueRequests(): CancelablePromise<TriggerDueRequestsResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payment-requests/trigger-due',
    });
  }
  /**
   * @param id
   * @returns TriggerRequestResponseDto
   * @throws ApiError
   */
  public paymentRequestControllerTrigger(
    id: string
  ): CancelablePromise<TriggerRequestResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payment-requests/{id}/trigger',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns TriggerRequestResponseDto
   * @throws ApiError
   */
  public paymentRequestControllerRetry(
    id: string
  ): CancelablePromise<TriggerRequestResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payment-requests/{id}/retry',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param idempotencyKey
   * @param requestBody
   * @returns string
   * @throws ApiError
   */
  public paymentsControllerCreateEmployer(
    idempotencyKey: string,
    requestBody: CreatePaymentsEmployerDto
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/employer',
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param idempotencyKey
   * @param requestBody
   * @returns string
   * @throws ApiError
   */
  public paymentsControllerLinkEmployerAccountToClientOrganization(
    idempotencyKey: string,
    requestBody: CreateEmployerBankAccountDto
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/employer/bank-account',
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param idempotencyKey
   * @param requestBody
   * @returns CreateEmployeePaymentsAccountResponseDto
   * @throws ApiError
   */
  public paymentsControllerCreateEmployee(
    employeeId: string,
    idempotencyKey: string,
    requestBody: CreatePaymentsEmployee
  ): CancelablePromise<CreateEmployeePaymentsAccountResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/employee/{employeeId}',
      path: {
        employeeId: employeeId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @returns GetEmployeePaymentsAccount
   * @throws ApiError
   */
  public paymentsControllerGetEmployeePaymentsAccount(
    employeeId: string
  ): CancelablePromise<GetEmployeePaymentsAccount> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payments/employee/{employeeId}',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns EmployeePaymentsAccountStatusDto
   * @throws ApiError
   */
  public paymentsControllerGetEmployeePaymentsAccountStatus(
    employeeId: string
  ): CancelablePromise<EmployeePaymentsAccountStatusDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payments/employee/{employeeId}/account-status',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns EmployeeBankAccountResponseDto
   * @throws ApiError
   */
  public paymentsControllerGetEmployeeBankAccount(
    employeeId: string
  ): CancelablePromise<EmployeeBankAccountResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payments/employee/{employeeId}/bank-account',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employeeId
   * @param cardIdentifier
   * @returns VgsCardInfoResponseDto
   * @throws ApiError
   */
  public paymentsControllerGetVgsCardInfo(
    employeeId: string,
    cardIdentifier: string
  ): CancelablePromise<VgsCardInfoResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payments/employee/card/info',
      query: {
        employeeId: employeeId,
        cardIdentifier: cardIdentifier,
      },
    });
  }
  /**
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public paymentsControllerCreateInitialDraw(
    idempotencyKey: string,
    requestBody: CreateInitialDrawDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/initial-draw',
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public paymentsControllerCreateEmergencyReservePull(
    idempotencyKey: string,
    requestBody: CreateEmergencyReservePullDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/emergency-reserve-pull',
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param idempotencyKey
   * @param requestBody
   * @returns string
   * @throws ApiError
   */
  public paymentsControllerCreateBookTransfer(
    idempotencyKey: string,
    requestBody: CreateBookTransferDto
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/book-transfer',
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param openEnrollmentPeriodId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public paymentsControllerUpdateInitialDraw(
    openEnrollmentPeriodId: string,
    idempotencyKey: string,
    requestBody: UpdateInitialDrawDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/payments/initial-draw/{openEnrollmentPeriodId}',
      path: {
        openEnrollmentPeriodId: openEnrollmentPeriodId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param openEnrollmentPeriodId
   * @returns void
   * @throws ApiError
   */
  public paymentsControllerCancelInitialDraw(
    openEnrollmentPeriodId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/payments/initial-draw/{openEnrollmentPeriodId}/cancel',
      path: {
        openEnrollmentPeriodId: openEnrollmentPeriodId,
      },
    });
  }
  /**
   * @param employeeId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public paymentsControllerCreateInitialAllocation(
    employeeId: string,
    idempotencyKey: string,
    requestBody: CreateInitialAllocationDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/employee/{employeeId}/initial-allocation',
      path: {
        employeeId: employeeId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param idempotencyKey
   * @param requestBody
   * @returns string
   * @throws ApiError
   */
  public paymentsControllerCreateDeallocation(
    employeeId: string,
    idempotencyKey: string,
    requestBody: CreateDeallocationDto
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/employee/{employeeId}/deallocation',
      path: {
        employeeId: employeeId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param idempotencyKey
   * @param requestBody
   * @returns string
   * @throws ApiError
   */
  public paymentsControllerCreateDeallocationForDeletedBenefit(
    employeeId: string,
    idempotencyKey: string,
    requestBody: CreateDeallocationForDeletedBenefitDto
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/employee/{employeeId}/deallocation/deleted-benefit',
      path: {
        employeeId: employeeId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public paymentsControllerCreateEmployeeReserveAccount(
    employeeId: string,
    idempotencyKey: string,
    requestBody: CreateEmployeeReserveAccountDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/employee/{employeeId}/reserve-account',
      path: {
        employeeId: employeeId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public paymentsControllerUpdateEmployeeReservePurseAmount(
    employeeId: string,
    idempotencyKey: string,
    requestBody: UpdateEmployeeReservePurseAmountDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/payments/employee/{employeeId}/reserve-account',
      path: {
        employeeId: employeeId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param idempotencyKey
   * @param requestBody
   * @returns MonthlyBillingContributionResponseDto
   * @throws ApiError
   */
  public paymentsControllerCreateMonthlyBillingContribution(
    idempotencyKey: string,
    requestBody: CreateMonthlyBillingContributionDto
  ): CancelablePromise<MonthlyBillingContributionResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/monthly-billing/contribution',
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param flowId
   * @param idempotencyKey
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public paymentsControllerCreateMonthlyBillingAllocations(
    flowId: string,
    idempotencyKey: string,
    requestBody: CreateMonthlyBillingAllocationsDto
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/monthly-billing/{flowId}/allocations',
      path: {
        flowId: flowId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param employeeId
   * @param idempotencyKey
   * @returns string
   * @throws ApiError
   */
  public paymentsControllerCreateEmployeeCard(
    employeeId: string,
    idempotencyKey: string
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/employee/{employeeId}/employee-card',
      path: {
        employeeId: employeeId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
    });
  }
  /**
   * @param employeeId
   * @returns EmployeeCardsDto
   * @throws ApiError
   */
  public paymentsControllerGetEmployeeCards(
    employeeId: string
  ): CancelablePromise<EmployeeCardsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payments/employee/{employeeId}/cards',
      path: {
        employeeId: employeeId,
      },
    });
  }
  /**
   * @param employerId
   * @param referenceIdentifier
   * @returns any
   * @throws ApiError
   */
  public paymentsControllerDeletePendingAchPush(
    employerId: string,
    referenceIdentifier: string
  ): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/payments/employer/{employerId}/ach-push/{referenceIdentifier}',
      path: {
        employerId: employerId,
        referenceIdentifier: referenceIdentifier,
      },
    });
  }
  /**
   * @param employerId
   * @returns EmployerKybStatusResponseDto
   * @throws ApiError
   */
  public paymentsControllerGetEmployerKybStatus(
    employerId: string
  ): CancelablePromise<EmployerKybStatusResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payments/employer/{employerId}/kyb-status',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employerId
   * @returns EmployerExternalBankAccountDetailsResponseDto
   * @throws ApiError
   */
  public paymentsControllerGetEmployerExternalBankAccountDetails(
    employerId: string
  ): CancelablePromise<EmployerExternalBankAccountDetailsResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payments/employer/{employerId}/external-bank-account',
      path: {
        employerId: employerId,
      },
    });
  }
  /**
   * @param employeeId
   * @param benefitId
   * @returns InitialAllocationStatusResponseDto
   * @throws ApiError
   */
  public paymentsControllerGetInitialAllocationStatus(
    employeeId: string,
    benefitId: string
  ): CancelablePromise<InitialAllocationStatusResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payments/employee/{employeeId}/benefit/{benefitId}/initial-allocation-status',
      path: {
        employeeId: employeeId,
        benefitId: benefitId,
      },
    });
  }
  /**
   * @param employeeId
   * @param benefitId
   * @returns boolean
   * @throws ApiError
   */
  public paymentsControllerHasInitialAllocation(
    employeeId: string,
    benefitId: string
  ): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payments/employee/{employeeId}/benefit/{benefitId}/has-initial-allocation',
      path: {
        employeeId: employeeId,
        benefitId: benefitId,
      },
    });
  }
  /**
   * @param employeeId
   * @param benefitId
   * @returns boolean
   * @throws ApiError
   */
  public paymentsControllerGetIsFirstAllocationSucceeded(
    employeeId: string,
    benefitId: string
  ): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payments/employee/{employeeId}/benefit/{benefitId}/is-first-allocation-succeeded',
      path: {
        employeeId: employeeId,
        benefitId: benefitId,
      },
    });
  }
  /**
   * @param employeeId
   * @param idempotencyKey
   * @param requestBody
   * @returns string
   * @throws ApiError
   */
  public paymentsControllerCreateImmediateAllocation(
    employeeId: string,
    idempotencyKey: string,
    requestBody: CreateImmediateAllocationDto
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payments/employee/{employeeId}/immediate-allocation',
      path: {
        employeeId: employeeId,
      },
      headers: {
        'idempotency-key': idempotencyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param searchTerm
   * @returns SearchResultDto
   * @throws ApiError
   */
  public searchControllerSearch(
    searchTerm: string
  ): CancelablePromise<Array<SearchResultDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/search',
      query: {
        searchTerm: searchTerm,
      },
    });
  }
  /**
   * @param employeeId
   * @param benefitId
   * @param requestBody
   * @returns CreateApplicationResultDto
   * @throws ApiError
   */
  public applicationsControllerCreateAutomaticApplication(
    employeeId: string,
    benefitId: string,
    requestBody: CreateAutomaticApplicationDto
  ): CancelablePromise<CreateApplicationResultDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/applications/{employeeId}/automatic',
      path: {
        employeeId: employeeId,
      },
      query: {
        benefitId: benefitId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param benefitId
   * @returns SubmittedApplicationResultDto
   * @throws ApiError
   */
  public applicationsControllerGetSubmittedApplication(
    benefitId: string
  ): CancelablePromise<SubmittedApplicationResultDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/applications/submitted',
      query: {
        benefitId: benefitId,
      },
    });
  }
  /**
   * @param benefitId
   * @returns CarrierPaymentDto
   * @throws ApiError
   */
  public applicationsControllerGetPayment(
    benefitId: string
  ): CancelablePromise<CarrierPaymentDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/applications/payment',
      query: {
        benefitId: benefitId,
      },
    });
  }
  /**
   * @param benefitId
   * @returns void
   * @throws ApiError
   */
  public applicationsControllerCancelApplication(
    benefitId: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/applications/cancel',
      query: {
        benefitId: benefitId,
      },
    });
  }
  /**
   * @param hiosId
   * @param planYear
   * @returns PlanAttestationsDto
   * @throws ApiError
   */
  public applicationsControllerGetPlanAttestations(
    hiosId: string,
    planYear: number
  ): CancelablePromise<PlanAttestationsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/applications/plan-attestations',
      query: {
        hiosId: hiosId,
        planYear: planYear,
      },
    });
  }
  /**
   * @param employeeId
   * @param benefitId
   * @returns AvailableSubmissionMethodsDto
   * @throws ApiError
   */
  public applicationsControllerGetAvailableSubmissionMethods(
    employeeId: string,
    benefitId: string
  ): CancelablePromise<AvailableSubmissionMethodsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/applications/{employeeId}/available-submission-methods',
      path: {
        employeeId: employeeId,
      },
      query: {
        benefitId: benefitId,
      },
    });
  }
  /**
   * @param employeeId
   * @param benefitId
   * @returns string
   * @throws ApiError
   */
  public applicationsControllerGenerateDeeplink(
    employeeId: string,
    benefitId: string
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/applications/{employeeId}/deeplink',
      path: {
        employeeId: employeeId,
      },
      query: {
        benefitId: benefitId,
      },
    });
  }
  /**
   * Get the truthful enrollment representation for the Copilot
   * Returns an EnrollmentDto for one MAJOR_MEDICAL benefit, assembled from Zorro internals. Keyed by benefitId — mirroring the carrier-application actions (deeplink / EnrollConnect), which are all per-benefit: a carrier submission is one plan at one carrier. The onboarding period is derived from the benefit and supplies context (coverage dates, plan year, allowance, QLE, AOR). Normalized/aggregated but not consumer-shaped; the extension adapts it. Requires the benefit to be past IN_CART.
   * @param employeeId
   * @param benefitId
   * @returns EnrollmentDto
   * @throws ApiError
   */
  public enrollmentCopilotControllerGetEnrollment(
    employeeId: string,
    benefitId: string
  ): CancelablePromise<EnrollmentDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/enrollment-copilot/enrollments/{employeeId}',
      path: {
        employeeId: employeeId,
      },
      query: {
        benefitId: benefitId,
      },
    });
  }
  /**
   * Generate the ICHRA letter and file it on the enrollment
   * Generates the ICHRA letter and saves it as a QLE-typed benefit document, so it appears in specialEnrollment.documents[] and can be opened like any other proof. Exposed because the letter is otherwise only produced as a side effect of carrier submission, which leaves an OFFERED_ICHRA enrollment with no proof on file until someone submits. Idempotent in effect but not in storage: each call files another letter, the same as the submission flow does. Returns the refreshed enrollment so the caller sees the new document without a second request.
   * @param employeeId
   * @param benefitId
   * @returns EnrollmentSepDocumentDto
   * @throws ApiError
   */
  public enrollmentCopilotControllerGenerateIchraLetter(
    employeeId: string,
    benefitId: string
  ): CancelablePromise<EnrollmentSepDocumentDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/enrollment-copilot/enrollments/{employeeId}/ichra-letter',
      path: {
        employeeId: employeeId,
      },
      query: {
        benefitId: benefitId,
      },
    });
  }
  /**
   * @param employeeId
   * @returns DiscoveryAiChatImpersonationAccessDto
   * @throws ApiError
   */
  public discoveryAiChatControllerGetImpersonationAccess(
    employeeId: string
  ): CancelablePromise<DiscoveryAiChatImpersonationAccessDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/discovery-ai-chat/impersonation-access',
      path: {
        employeeId: employeeId,
      },
    });
  }
}
